{
  "401": {
    "title": "Bạn không có quyền truy cập trang này.",
    "text": "Nếu bạn cho rằng đây là sự nhầm lẫn, vui lòng liên hệ quản trị viên",
    "back_button": "Quay lại trang chủ"
  },
  "403": {
    "title": "Bạn không có quyền truy cập trang này.",
    "text": "Nếu bạn cho rằng đây là sự nhầm lẫn, vui lòng liên hệ quản trị viên.",
    "back_button": "Quay lại trang chủ"
  },
  "404": {
    "title": "Không tìm thấy trang này.",
    "text": "Không thể tìm thấy trang được yêu cầu.",
    "back_button": "Quay lại trang chủ"
  },
  "general": {
    "dateFormat": "dd/MM/yyyy",
    "fullDateFormat": "dd/MM/yyyy HH:mm:ss",
    "logout": "Đăng xuất",
    "account": "Tài khoản",
    "profile": "Hồ sơ",
    "hello": "Xin chào",
    "home": "Trang chủ",
    "loading": "Đang tải...",
    "confirm": "Xác nhận",
    "cancel": "Hủy",
    "close": "Đóng",
    "view": "Xem",
    "save": "Lưu",
    "records": "Bản ghi",
    "add": "Thêm",
    "read": "Đọc",
    "write": "Lưu",
    "edit": "Chỉnh sửa",
    "new": "Mới",
    "delete": "Xóa",
    "actions": "Hành động",
    "active": "Đang hoạt động",
    "inactive": "Không hoạt động",
    "search": "Tìm kiếm",
    "select": "Chọn",
    "none": "Không có",
    "yes": "Có",
    "no": "Không",
    "years": "Năm",
    "months": "Tháng",
    "favorites": "Yêu thích",
    "reports": "Báo cáo",
    "recordsPerPage": "Số bản ghi mỗi trang",
    "changePassword": "Đổi mật khẩu",
    "longDateFormat": "{years} năm và {months} tháng",
    "importData": "Nhập dữ liệu",
    "upload": "Tải lên",
    "downloadTemplate": "Tải mẫu",
    "selectOption": "Chọn một tùy chọn",
    "id": "ID",
    "translations": "Bản dịch",
    "or": "hoặc",
    "review": "Xem xét",
    "approve": "Phê duyệt",
    "reject": "Từ chối",
    "reviewComments": "Nhận xét đánh giá",
    "reviewOnBehalfOf": "Đánh giá thay cho",
    "reviewed": "Đã xem xét",
    "reviewedBy": "Người xem xét ",
    "pending": "Đang chờ",
    "approved": "Đã phê duyệt",
    "rejected": "Đã từ chối",
    "skipped": "Đã bỏ qua",
    "warning": "Cảnh báo",
    "manager": "Quản lý",
    "move": "Di chuyển",
    "leave": "Nghỉ phép",
    "export": "Xuất",
    "import": "Nhập",
    "next": "Tiếp theo",
    "previous": "Trước đó",
    "done": "Hoàn tất",
    "run": "Chạy",
    "form": "Biểu mẫu",
    "status": "Trạng thái",
    "emailTemplate": "Mẫu email",
    "send": "Gửi",
    "saving": "Đang lưu...",
    "saved": "Đã lưu",
    "loadData": "Tải dữ liệu",
    "download": "Tải xuống",
    "noData": "Không có dữ liệu trong bảng",
    "cropImage": "Cắt ảnh",
    "selectImageToCrop": "Chọn ảnh để cắt",
    "selectImage": "Chọn ảnh",
    "list": "Danh sách",
    "group": "Nhóm",
    "attach": "Đính kèm",
    "exportCsv": "Xuất CSV",
    "auditFields": "Trường kiểm toán",
    "saveDisplayOrder": "Lưu thứ tự hiển thị",
    "permissionActions": {
      "read": "Đọc",
      "write": "Ghi",
      "delete": "Xóa",
      "execute": "Thực thi"
    },
    "messages": {
      "personNotFound": "Không tìm thấy nhân viên. Vui lòng liên hệ quản trị viên.",
      "notRegisteredSessionOnly": "Bạn chưa được đăng ký trong JTP, vì vậy thay đổi này chỉ áp dụng cho phiên làm việc hiện tại của bạn. Vui lòng liên hệ quản trị viên để được thêm vào hệ thống.",
      "formUnsavedChanges": "Bạn có thay đổi chưa được lưu. Bạn có chắc chắn muốn đóng không?",
      "serverError": "Lỗi máy chủ. Vui lòng thử lại sau hoặc liên hệ quản trị viên hệ thống.",
      "networkError": "Không thể kết nối đến máy chủ. Vui lòng kiểm tra kết nối internet hoặc liên hệ quản trị viên hệ thống.",
      "forbidden": "Bạn không có quyền truy cập tài nguyên này. Vui lòng liên hệ quản trị viên hệ thống nếu bạn cho rằng đây là sự nhầm lẫn.",
      "fileUploadError": "Lỗi khi tải tệp lên. Vui lòng kiểm tra định dạng và kích thước tệp rồi thử lại.",
      "fileUploadSuccessEmail": "Tải tệp lên thành công. Email chứa kết quả nhập dữ liệu sẽ được gửi sớm.",
      "failedLoadPermissions": "Không thể tải quyền của người dùng. Vui lòng làm mới trang hoặc liên hệ quản trị viên hệ thống.",
      "downloadingFile": "Đang tải tệp xuống...",
      "fileDownloadError": "Lỗi khi tải tệp xuống. Vui lòng thử lại hoặc liên hệ quản trị viên hệ thống.",
      "fileImportedSuccessfully": "Nhập tệp thành công.",
      "invalidFileFormat": "Định dạng tệp không hợp lệ. Vui lòng kiểm tra tệp và thử lại.",
      "exportFailed": "Xuất dữ liệu không thành công. Vui lòng thử lại hoặc liên hệ quản trị viên hệ thống.",
      "unableGetPermissions": "JTP không thể lấy được quyền của bạn. Bạn có thể sử dụng quyền truy cập cơ bản cho đến khi vấn đề này được khắc phục"
    },
    "warnings": {
      "maxDisplayedRecords": "Đang hiển thị {shown} bản ghi trong tổng số {filtered}. Để xem thêm bản ghi, hãy sử dụng chức năng tìm kiếm."
    },
    "info": {
      "dragAndDropInfo": "Kéo và thả bất kỳ nhân viên nào để sắp xếp cây tổ chức"
    },
    "validation": {
      "required": "Trường này là bắt buộc.",
      "email": "Vui lòng nhập địa chỉ email hợp lệ.",
      "minValue": "Giá trị phải tối thiểu là {min}.",
      "maxValue": "Giá trị không được lớn hơn {max}.",
      "minLength": "Giá trị phải có tối thiểu {min} ký tự.",
      "maxLength": "Giá trị không được vượt quá {max} ký tự.",
      "onlyIntegers": "Giá trị phải là số nguyên.",
      "invalidDate": "Ngày nhập vào không hợp lệ.",
      "dateAfterOrEqual": "Ngày phải sau hoặc bằng {date}"
    },
    "baseAuditableEntity": {
      "createdBy": "Người tạo",
      "createdDate": "Ngày tạo",
      "modifiedBy": "Người sửa đổi",
      "modifiedDate": "Ngày sửa đổi"
    }
  },
  "enums": {
    "potentialSuccessorType": {
      "1": "Nội bộ",
      "2": "Bên ngoài"
    },
    "readinessFactor": {
      "0": "Không áp dụng",
      "1": "Sẵn sàng ngay",
      "2": "Sẵn sàng sau đào tạo (1-2 năm)",
      "3": "Sẵn sàng sau đào tạo (2-3 năm)",
      "4": "Thay thế khẩn cấp"
    },
    "positionType": {
      "1": "Mua",
      "2": "Sản xuất",
      "3": "Bán",
      "4": "Hỗ trợ"
    },
    "personStatus": {
      "1": "Đang hoạt động",
      "2": "Không hoạt động",
      "3": "Đã chấm dứt"
    },
    "communicationPriority": {
      "1": "Bình thường",
      "2": "Cao"
    },
    "personTypes": {
      "0": "Không xác định",
      "1": "Nhân viên hưởng lương",
      "2": "Nhà thầu",
      "3": "Nhà cung cấp",
      "4": "Nhân viên theo giờ",
      "5": "Bên ngoài",
      "6": "DU theo giờ - Không hoạt động",
      "7": "DU hưởng lương - Không hoạt động",
      "8": "DU tài xế xe tải",
      "9": "Điều hành cấp cao",
      "10": "Công đoàn",
      "11": "Không công đoàn",
      "12": "Có thể tham gia công đoàn",
      "13": "Hưởng lương không miễn trừ",
      "14": "Theo giờ",
      "15": "DU nghỉ phép có lương",
      "17": "Tài xế xe tải",
      "18": "DU nghỉ phép không lương",
      "19": "Trả tự do có điều kiện",
      "20": "Truy cập bên ngoài cấp độ 1",
      "21": "Truy cập bên ngoài cấp độ 2",
      "22": "Truy cập bên ngoài cấp độ 3",
      "23": "Truy cập bên ngoài cấp độ 4",
      "24": "Truy cập bên ngoài cấp độ 5",
      "99": "Nhân viên toàn cầu"
    },
    "customerSpecificStatus": {
      "0": "Không xác định",
      "1": "Đang hoạt động",
      "2": "Không hoạt động",
      "3": "Trợ cấp thu nhập",
      "4": "Nghỉ phép dài hạn",
      "5": "Đã nghỉ hưu",
      "6": "Đã rút lui"
    },
    "resourceType": {
      "1": "Ứng dụng",
      "2": "Mô-đun",
      "3": "Trang",
      "4": "Phần trang",
      "5": "Hành động trang",
      "6": "Trường trang",
      "7": "Dữ liệu"
    },
    "securityResourceAction": {
      "0": "Không có",
      "1": "Đọc",
      "2": "Ghi",
      "3": "Đọc và Ghi",
      "4": "Thực thi",
      "5": "Đọc và Thực thi",
      "6": "Ghi và Thực thi",
      "7": "Đọc, Ghi và Thực thi",
      "8": "Xóa",
      "9": "Đọc và Xóa",
      "10": "Ghi và Xóa",
      "11": "Đọc, Ghi và Xóa",
      "12": "Thực thi và Xóa",
      "13": "Đọc, Thực thi và Xóa",
      "14": "Ghi, Thực thi và Xóa",
      "15": "Tất cả"
    }
  },
  "report": {
    "viewer": {
      "grid": {
        "pivotMode": "Chế độ Pivot",
        "groups": "Nhóm hàng",
        "rowGroupColumnsEmptyMessage": "Kéo vào đây để thiết lập nhóm hàng",
        "values": "Giá trị",
        "valueColumnsEmptyMessage": "Kéo vào đây để tổng hợp",
        "pivots": "Nhãn cột",
        "pivotColumnsEmptyMessage": "Kéo vào đây để thiết lập nhãn cột",
        "columns": "Cột",
        "filters": "Bộ lọc",
        "loadingOoo": "Đang tải...",
        "noRowsToShow": "Không có hàng nào để hiển thị",
        "enabled": "Đã bật",
        "group": "Nhóm",
        "footerTotal": "Tổng",
        "filterOoo": "Lọc...",
        "searchOoo": "Tìm kiếm...",
        "blanks": "(Trống)",
        "selectAll": "(Chọn tất cả)",
        "selectAllSearchResults": "(Chọn tất cả kết quả tìm kiếm)",
        "noMatches": "Không có kết quả phù hợp",
        "equals": "Bằng",
        "notEqual": "Không bằng",
        "blank": "Trống",
        "notBlank": "Không trống",
        "lessThan": "Nhỏ hơn",
        "greaterThan": "Lớn hơn",
        "lessThanOrEqual": "Nhỏ hơn hoặc bằng",
        "greaterThanOrEqual": "Lớn hơn hoặc bằng",
        "inRange": "Trong khoảng",
        "inRangeStart": "Từ",
        "inRangeEnd": "Đến",
        "contains": "Chứa",
        "notContains": "Không chứa",
        "startsWith": "Bắt đầu bằng",
        "endsWith": "Kết thúc bằng",
        "before": "Trước",
        "after": "Sau",
        "andCondition": "VÀ",
        "orCondition": "HOẶC",
        "applyFilter": "Áp dụng",
        "resetFilter": "Đặt lại",
        "clearFilter": "Xóa",
        "cancelFilter": "Hủy",
        "textFilter": "Bộ lọc văn bản",
        "numberFilter": "Bộ lọc số",
        "dateFilter": "Bộ lọc ngày",
        "setFilter": "Bộ lọc tập hợp",
        "pinColumn": "Ghim cột",
        "pinLeft": "Ghim trái",
        "pinRight": "Ghim phải",
        "noPin": "Không ghim",
        "valueAggregation": "Tổng hợp giá trị",
        "noAggregation": "Không",
        "autosizeThisColumn": "Tự động điều chỉnh cột này",
        "autosizeAllColumns": "Tự động điều chỉnh tất cả các cột",
        "groupBy": "Nhóm theo",
        "ungroupBy": "Bỏ nhóm theo",
        "ungroupAll": "Bỏ nhóm tất cả",
        "addToValues": "Thêm {'${variable}'} vào giá trị",
        "removeFromValues": "Xóa {'${variable}'} khỏi giá trị",
        "addToLabels": "Thêm {'${variable}'} vào nhãn",
        "removeFromLabels": "Xóa {'${variable}'} khỏi nhãn",
        "resetColumns": "Đặt lại cột",
        "expandAll": "Mở rộng tất cả nhóm hàng",
        "collapseAll": "Thu gọn tất cả nhóm hàng",
        "copy": "Sao chép",
        "copyWithHeaders": "Sao chép kèm tiêu đề",
        "copyWithGroupHeaders": "Sao chép kèm tiêu đề nhóm",
        "cut": "Cắt",
        "paste": "Dán",
        "export": "Xuất",
        "csvExport": "Xuất CSV",
        "excelExport": "Xuất Excel",
        "sum": "Tổng",
        "first": "Đầu tiên",
        "last": "Cuối cùng",
        "min": "Nhỏ nhất",
        "max": "Lớn nhất",
        "count": "Đếm",
        "avg": "Trung bình",
        "average": "Trung bình",
        "filteredRows": "Đã lọc",
        "selectedRows": "Đã chọn",
        "totalRows": "Tổng số hàng",
        "totalAndFilteredRows": "Hàng"
      },
      "noFilterMessage": "Không có bộ lọc cho báo cáo này",
      "noAccessReport": "Bạn không có quyền xem báo cáo này. Vui lòng liên hệ quản trị viên hệ thống nếu bạn cho rằng đây là sự nhầm lẫn.",
      "pdfSizeErrorMessage": "Kích thước tệp PDF quá lớn và không thể hiển thị.",
      "pdfMaxSizeDownloaded": "Báo cáo quá lớn để hiển thị. Vui lòng kiểm tra thư mục tải xuống của bạn.",
      "failedLoadReports": "Không thể tải báo cáo. Các tính năng khác vẫn hoạt động bình thường. Vui lòng làm mới trang hoặc liên hệ quản trị viên hệ thống nếu vấn đề vẫn tiếp diễn.",
      "run": "Chạy",
      "download": "Tải xuống",
      "viewFilter": {
        "button": "Xem bộ lọc...",
        "title": "Tham số",
        "name": "Tên",
        "value": "Giá trị"
      },
      "fullScreen": "Toàn màn hình...",
      "smallScreen": "Thu nhỏ màn hình...",
      "tabButton": {
        "fullScreen": "Ẩn phần tham số",
        "smallScreen": "Hiện phần tham số",
        "about": "Giới thiệu",
        "downloadExcel": "Tải tệp bảng tính",
        "clear": "Đóng tất cả các thẻ"
      },
      "modalAbout": {
        "title": "Giới thiệu",
        "description": "Mô tả",
        "version": "Phiên bản",
        "reference": "Tham chiếu",
        "lastChange": "Thay đổi gần nhất",
        "dataSource": "Nguồn dữ liệu"
      }
    },
    "maintenance": {
      "menuName": "Báo cáo",
      "pageTitle": "Báo cáo",
      "id": "ID",
      "title": "Tiêu đề",
      "reference": "Tham chiếu",
      "directoryTree": "Cây thư mục",
      "directoryTreeHelp": "Sử dụng dấu gạch chéo ngược để phân tách thư mục, ví dụ: Reports\\Finance\\Monthly",
      "reportType": "Loại báo cáo",
      "typeGrid": "Lưới",
      "typeForm": "Biểu mẫu",
      "securityResource": "Tài nguyên bảo mật",
      "description": "Mô tả",
      "versionNumber": "Phiên bản",
      "isActive": "Đang hoạt động",
      "lastModified": "Sửa đổi lần cuối",
      "isSchedulable": "Có thể lên lịch",
      "isArchivable": "Có thể lưu trữ",
      "isAuditable": "Có thể kiểm toán",
      "passMultiValue": "Truyền nhiều giá trị dưới dạng chuỗi",
      "expireInDays": "Hết hạn sau (ngày)",
      "add": "Thêm báo cáo",
      "edit": "Chỉnh sửa báo cáo",
      "delete": {
        "title": "Xóa báo cáo",
        "text": "Bạn có chắc chắn muốn xóa \"{name}\" không?"
      },
      "messages": {
        "created": "Tạo báo cáo thành công.",
        "updated": "Lưu báo cáo thành công.",
        "deleted": "Xóa báo cáo thành công.",
        "imported": "Nhập báo cáo thành công."
      },
      "sections": {
        "main": "Thuộc tính chính",
        "parameters": "Tham số",
        "sqls": "Câu lệnh SQL",
        "grids": "Lưới kết quả",
        "models": "Mô hình báo cáo"
      },
      "sql": {
        "add": "Thêm câu lệnh SQL",
        "edit": "Chỉnh sửa câu lệnh SQL",
        "description": "Mô tả",
        "connection": "Kết nối",
        "multipleResultset": "Nhiều tập kết quả",
        "sql": "SQL",
        "generateGrids": "Tạo lưới từ SQL",
        "generateGridsSuccess": "Tạo lưới thành công. Vui lòng xem lại trong tab Lưới kết quả.",
        "delete": {
          "title": "Xóa câu lệnh SQL",
          "text": "Bạn có chắc chắn muốn xóa \"{name}\" không?"
        }
      },
      "grid": {
        "add": "Thêm lưới",
        "edit": "Chỉnh sửa lưới",
        "label": "Nhãn",
        "resultsetNumber": "Số thứ tự tập kết quả",
        "parentGrid": "Lưới cha",
        "defaultGroupedColumns": "Cột nhóm mặc định",
        "relationString": "Chuỗi quan hệ",
        "delete": {
          "title": "Xóa lưới",
          "text": "Bạn có chắc chắn muốn xóa \"{name}\" không?"
        }
      },
      "column": {
        "add": "Thêm cột",
        "edit": "Chỉnh sửa cột",
        "columnName": "Tên cột",
        "label": "Nhãn",
        "header": "Tiêu đề",
        "dataType": "Kiểu dữ liệu",
        "sumarizeType": "Tổng hợp",
        "showOrder": "Thứ tự",
        "mask": "Mặt nạ",
        "helpText": "Văn bản trợ giúp",
        "template": "Mẫu",
        "delete": {
          "title": "Xóa cột",
          "text": "Bạn có chắc chắn muốn xóa \"{name}\" không?"
        }
      },
      "param": {
        "add": "Thêm tham số",
        "edit": "Chỉnh sửa tham số",
        "displayOrder": "Thứ tự",
        "name": "Tên",
        "nameValidation": "Chỉ cho phép chữ cái, số và dấu gạch dưới.",
        "label": "Nhãn",
        "dataType": "Kiểu dữ liệu",
        "defaultValue": "Giá trị mặc định",
        "helpText": "Văn bản trợ giúp",
        "required": "Bắt buộc",
        "multiple": "Nhiều giá trị",
        "width": "Độ rộng (cột)",
        "enumValues": "Giá trị (phân tách bằng dấu chấm phẩy)",
        "enumValuesHelp": "ví dụ: 1;2;3",
        "enumLabels": "Nhãn (phân tách bằng dấu chấm phẩy)",
        "enumLabelsHelp": "ví dụ: Tùy chọn A;Tùy chọn B;Tùy chọn C",
        "sql": "Truy vấn SQL",
        "generate": "Tạo tham số từ SQL",
        "delete": {
          "title": "Xóa tham số",
          "text": "Bạn có chắc chắn muốn xóa \"{name}\" không?"
        }
      },
      "model": {
        "add": "Thêm mô hình",
        "edit": "Chỉnh sửa mô hình",
        "description": "Mô tả",
        "order": "Thứ tự",
        "connection": "Kết nối",
        "file": "Tệp mô hình (.trdx / .trdp)",
        "fileLoaded": "Tải tệp thành công.",
        "delete": {
          "title": "Xóa mô hình",
          "text": "Bạn có chắc chắn muốn xóa \"{name}\" không?"
        }
      },
      "paramDataType": {
        "text": "Văn bản",
        "number": "Số",
        "date": "Ngày",
        "time": "Giờ",
        "combo": "Danh sách chọn",
        "boolean": "Boolean",
        "sql": "SQL"
      },
      "colDataType": {
        "text": "Văn bản",
        "number": "Số",
        "date": "Ngày",
        "time": "Giờ",
        "combo": "Danh sách chọn",
        "boolean": "Boolean"
      },
      "sumarizeType": {
        "nosumarize": "Không",
        "sum": "Tổng",
        "min": "Nhỏ nhất",
        "max": "Lớn nhất",
        "average": "Trung bình",
        "count": "Đếm"
      },
      "import": {
        "connection": "Ghi đè kết nối",
        "connectionHelp": "Tùy chọn: ghi đè tất cả các tham chiếu kết nối trong tệp đã nhập."
      }
    }
  },
  "file": {
    "description": "Mô tả",
    "files": "Tệp",
    "editDescription": "Chỉnh sửa mô tả",
    "delete": "Xóa tệp",
    "download": "Tải tệp xuống",
    "pendingUpload": "Đang chờ tải lên. Tệp chỉ được lưu sau khi nhấn 'Lưu'.",
    "noFiles": "Chưa có tệp nào được thêm."
  },
  "dashboard": {
    "menuTitle": "Bảng điều khiển",
    "title": "Bảng điều khiển",
    "addWidget": "Thêm tiện ích",
    "editLayout": "Chỉnh sửa bố cục",
    "saveLayout": "Lưu bố cục",
    "importLayout": "Nhập bố cục",
    "exportLayout": "Xuất bố cục",
    "category": "Danh mục",
    "widget": "Tiện ích",
    "widgetTitle": "Tiêu đề",
    "widgetParameters": "Tham số",
    "widgetInformation": "Thông tin tiện ích",
    "noParameters": "Tiện ích này không có tham số.",
    "delete": "Xóa tiện ích",
    "viewLink": "xem",
    "noItemsToDisplay": "Không có mục nào để hiển thị",
    "messages": {
      "saveSuccess": "Lưu bố cục thành công.",
      "importSuccess": "Nhập bố cục thành công.",
      "exportSuccess": "Xuất bố cục thành công.",
      "importFailed": "Không thể nhập bố cục.",
      "widgetNotFound": "Không tìm thấy tiện ích",
      "failedToLoad": "Không thể tải",
      "noDataAvailable": "Không có dữ liệu",
      "noParametersConfigured": "Chưa có tham số nào được cấu hình cho tiện ích này."
    },
    "tutorial": {
      "mainMessage": "Chào mừng bạn đến với bảng điều khiển! Hãy sử dụng các nút phía trên để tùy chỉnh.",
      "callToAction": "Hướng dẫn tôi!",
      "instructions": {
        "add": {
          "title": "Nút Thêm tiện ích",
          "description": "Tại đây, bạn có thể tìm các tiện ích theo danh mục. Một số tiện ích có thể có tham số cho phép bạn tùy chỉnh bảng điều khiển hoàn toàn. Đừng quên nhấn LƯU sau khi thêm tất cả các tiện ích của bạn."
        },
        "edit": {
          "title": "Chỉnh sửa bố cục tiện ích",
          "description": "Tại đây, bạn có thể thay đổi bảng điều khiển của mình: thêm hoặc xóa tiện ích, di chuyển và thay đổi kích thước. Đừng quên nhấn lưu sau khi chỉnh sửa."
        },
        "import": {
          "title": "Nhập bố cục",
          "description": "Với tệp sao lưu, bạn có thể nhập tại đây. Lưu ý: bảng điều khiển của bạn sẽ bị ghi đè."
        },
        "export": {
          "title": "Xuất bố cục",
          "description": "Sau khi hoàn tất bảng điều khiển, bạn có thể xuất để sao lưu HOẶC gửi cho người dùng khác để sao chép bảng điều khiển của bạn."
        }
      }
    }
  },
  "communication": {
    "title": "Thông báo",
    "menuTitle": "Thông báo",
    "menuName": "Thông báo",
    "markAsRead": "Đánh dấu đã đọc",
    "subject": "Chủ đề",
    "date": "Ngày",
    "priority": "Mức độ ưu tiên",
    "backToInbox": "Quay lại hộp thư",
    "noMessages": "Không có tin nhắn nào trong hộp thư của bạn.",
    "status": "Trạng thái",
    "read": "Đã đọc",
    "unread": "Chưa đọc",
    "edit": "Xem",
    "messages": {
      "markedAsRead": "Đã xác nhận thông báo"
    }
  },
  "settings": {
    "title": "Cài đặt",
    "theme": {
      "name": "Giao diện",
      "dark": "Tối",
      "light": "Sáng"
    }
  },
  "userInfo": {
    "title": "Thông tin người dùng",
    "permissions": "Quyền",
    "userName": "Tên đăng nhập",
    "fullName": "Họ và tên",
    "email": "Email",
    "employeeId": "Mã nhân viên",
    "action": "Hành động",
    "permissionCode": "Mã quyền"
  },
  "profile": {
    "title": "Hồ sơ của tôi",
    "menuName": "Hồ sơ",
    "score": "Điểm hồ sơ",
    "managerWarning": "Thông tin cung cấp trong trang 'Hồ sơ của tôi' có thể được Quản lý và bộ phận Nhân sự trong tổ chức truy cập cho mục đích lập bản đồ nhân tài.",
    "photo": "Đổi ảnh đại diện",
    "name": "Tên",
    "email": "Email",
    "manager": "Quản lý",
    "position": "Vị trí",
    "plant": "Nhà máy",
    "businessArea": "Khu vực kinh doanh",
    "degreeType": "Bằng cấp",
    "degreeName": "Tên bằng cấp hoặc chứng chỉ tại đây",
    "language": "Ngôn ngữ",
    "languagesInfo": "Chọn tất cả các ngôn ngữ bạn sử dụng",
    "geoMobility": {
      "label": "Khả năng di chuyển địa lý",
      "none": "Không",
      "local": "Trong nước",
      "national": "Toàn quốc",
      "international": "Quốc tế",
      "nationalAndInternational": "Toàn quốc và Quốc tế"
    },
    "businessMobility": "Khả năng di chuyển giữa các đơn vị kinh doanh",
    "skills": "Kỹ năng của tôi",
    "skillsInfo": "Chọn các lĩnh vực chuyên môn của bạn",
    "careerInterests": "Định hướng nghề nghiệp",
    "careerAspirations": "Khát vọng nghề nghiệp",
    "jobHistory": "Lịch sử công việc liên quan",
    "save": "Lưu",
    "invalidPhotoFormat": "Định dạng tệp không được hỗ trợ. Vui lòng sử dụng PNG hoặc JPEG.",
    "photoCrop": {
      "title": "Ảnh hồ sơ",
      "selectImage": "Tải lên",
      "confirm": "Áp dụng",
      "cancel": "Hủy",
      "deletePhoto": "Xóa",
      "hint": "Kéo để di chuyển. Chụm hoặc cuộn để phóng to/thu nhỏ.",
      "emptyState": "Chưa chọn ảnh. Nhấn \"Tải lên\" để bắt đầu."
    },
    "messages": {
      "saved": "Lưu hồ sơ thành công",
      "notRegistered": "Bạn chưa được đăng ký trong JTP. Vui lòng liên hệ bộ phận Nhân sự để được thêm vào hệ thống. Cho đến lúc đó, quyền truy cập của bạn sẽ bị hạn chế."
    }
  },
  "impersonate": {
    "title": "Đăng nhập thay người dùng",
    "userName": "Đăng nhập",
    "start": "Bắt đầu đăng nhập thay",
    "messages": {
      "impersonationStarted": "Đã bắt đầu phiên đăng nhập thay. Để quay lại tài khoản của bạn, vui lòng đăng xuất và đăng nhập lại.",
      "userNotFound": "Không tìm thấy người dùng. Vui lòng kiểm tra tên đăng nhập và thử lại."
    }
  },
  "about": {
    "menuName": "Giới thiệu",
    "title": "Giới thiệu"
  },
  "releaseNotes": {
    "menuName": "Ghi chú phát hành",
    "title": "Ghi chú phát hành",
    "name": "Tên",
    "version": "Phiên bản",
    "description": "Mô tả",
    "appType": "Loại ứng dụng",
    "releaseDate": "Ngày phát hành",
    "messages": {
      "notFound": "Không tìm thấy ghi chú phát hành.",
      "saveError": "Lỗi khi lưu ghi chú phát hành. Vui lòng thử lại sau."
    }
  },
  "help": {
    "menuTitle": "Trợ giúp",
    "externalLinkMessage": "Bạn sắp mở một liên kết bên ngoài:",
    "externalLinkConfirm": "Mở liên kết",
    "lastUpdated": "Cập nhật lần cuối: {date}",
    "wasThisHelpful": "Nội dung này có hữu ích không?",
    "helpful": "Hữu ích",
    "notHelpful": "Không hữu ích",
    "pageModal": {
      "title": "Trợ giúp cho trang này",
      "intro": "Các bài viết trợ giúp cung cấp hướng dẫn cho trang bạn đang xem. Chọn một bài viết để mở, hoặc đóng cửa sổ này."
    }
  },
  "admin": {
    "menuTitle": "Quản trị",
    "appCustomizations": {
      "menuName": "Tùy chỉnh ứng dụng",
      "pageTitle": "Tùy chỉnh ứng dụng",
      "imageLogos": "Logo hình ảnh",
      "headerLogo": "Logo tiêu đề",
      "menuLogo": "Logo menu",
      "bannerImage": "Ảnh banner",
      "upload": "Tải lên",
      "remove": "Xóa",
      "deleteConfirmTitle": "Xóa hình ảnh",
      "deleteConfirmText": "Bạn có chắc chắn muốn xóa hình ảnh này không? Hành động này không thể hoàn tác.",
      "noCustom": "Ảnh mặc định",
      "preview": "Xem trước",
      "messages": {
        "saved": "Lưu tùy chỉnh thành công.",
        "invalidKey": "Khóa logo không hợp lệ.",
        "invalidLanguage": "Mã ngôn ngữ không hợp lệ.",
        "fileRequired": "Tệp là bắt buộc.",
        "fileTooLarge": "Tệp vượt quá kích thước tối đa cho phép là 2 MB.",
        "fileTypeNotAllowed": "Loại tệp không được phép. Vui lòng sử dụng PNG, JPEG hoặc WebP.",
        "notFound": "Không tìm thấy tùy chỉnh."
      }
    },
    "help": {
      "menuName": "Trợ giúp",
      "pageTitle": "Trợ giúp",
      "title": "Tiêu đề",
      "description": "Mô tả",
      "isActive": "Đang hoạt động",
      "isMenuDisplayed": "Hiển thị trong menu",
      "isMenuDisplayedInfo": "Khi tắt, mục trợ giúp này sẽ bị ẩn khỏi menu Trợ giúp nhưng vẫn có thể mở được từ biểu tượng trợ giúp trên các trang liên quan.",
      "isTrackingEnabled": "Bật theo dõi",
      "isTrackingEnabledInfo": "Khi bật, lượt xem trang sẽ được ghi lại theo từng nhân viên và đánh giá \"nội dung này có hữu ích không\" sẽ hiển thị trên trang trợ giúp.",
      "viewCount": "Lượt xem",
      "viewCountValue": "Đã xem {views} lần bởi {viewers} người",
      "viewCountInfo": "Tổng số lượt xem và số lượng nhân viên khác nhau đã mở mục trợ giúp này.",
      "helpfulCount": "Hữu ích",
      "notHelpfulCount": "Không hữu ích",
      "displayOrder": "Thứ tự hiển thị",
      "securityResources": "Tài nguyên bảo mật",
      "securityResourcesInfo": "Danh sách quyền, phân tách bằng dấu phẩy. Để trống để mọi người đều xem được; nếu không, người dùng phải có ít nhất một trong các quyền được liệt kê.",
      "associatedMenus": "Trang liên kết",
      "associatedMenusInfo": "Gắn mục trợ giúp này với một hoặc nhiều trang để có thể mở trực tiếp từ biểu tượng trợ giúp trên các trang đó.",
      "addMenu": "Thêm trang",
      "add": "Thêm trợ giúp",
      "edit": "Chỉnh sửa trợ giúp",
      "delete": {
        "title": "Xóa trợ giúp",
        "text": "Bạn có chắc chắn muốn xóa mục trợ giúp này không?"
      },
      "messages": {
        "created": "Tạo mục trợ giúp thành công.",
        "updated": "Cập nhật mục trợ giúp thành công.",
        "deleted": "Xóa mục trợ giúp thành công.",
        "notFound": "Không tìm thấy mục trợ giúp."
      }
    },
    "menuHierarchy": {
      "menuName": "Cấu trúc menu",
      "pageTitle": "Cấu trúc menu",
      "displayName": "Tên hiển thị",
      "displayNameKey": "Isso????",
      "route": "Đường dẫn",
      "routeParam": "Tham số menu",
      "securityResources": "Tài nguyên bảo mật",
      "children": "Menu con",
      "isActive": "Đang hoạt động",
      "icon": "Biểu tượng",
      "iconHelpText": "Thư viện biểu tượng",
      "displayOrder": "Thứ tự hiển thị",
      "edit": "Chỉnh sửa mục menu",
      "messages": {
        "success": "Lưu mục menu thành công."
      }
    },
    "notificationTemplate": {
      "menuName": "Mẫu thông báo",
      "pageTitle": "Mẫu thông báo",
      "name": "Tên",
      "parent": "Mẫu cha",
      "parentInfo": "Chỉ các mẫu bắt đầu bằng masterTemplate mới có thể được sử dụng làm mẫu cha.",
      "pushNotificationEnabled": "Bật thông báo đẩy",
      "pushRoute": "Đường dẫn thông báo đẩy",
      "sqlQuery": "Truy vấn SQL",
      "sqlQueryDateFormatInfo": "Các cột ngày phải được định dạng theo mm/DD/yyyy.",
      "generalSection": "Thông tin chung",
      "emailSection": "Thông báo qua email",
      "emailSubject": "Tiêu đề email",
      "emailBody": "Nội dung email (HTML)",
      "pushSection": "Thông báo đẩy",
      "pushSubject": "Tiêu đề thông báo đẩy",
      "pushBody": "Nội dung thông báo đẩy",
      "overrideNotificationTemplate": "Ghi đè mẫu hiện có",
      "add": "Thêm mẫu",
      "edit": "Chỉnh sửa mẫu",
      "delete": {
        "title": "Xóa mẫu",
        "text": "Bạn có chắc chắn muốn xóa mẫu \"{name}\" không?"
      },
      "attachment": {
        "title": "Đính kèm tệp",
        "attachment": "Tệp đính kèm",
        "attach": "Đính kèm",
        "noAttachedFile": "Chưa có tệp đính kèm nào...",
        "messages": {
          "uploadedSuccessfully": "Tải tệp đính kèm lên thành công."
        },
        "delete": {
          "title": "Xóa tệp đính kèm",
          "text": "Bạn có chắc chắn muốn xóa tệp đính kèm \"{name}\" không?"
        }
      },
      "messages": {
        "created": "Tạo mẫu thông báo thành công.",
        "updated": "Cập nhật mẫu thông báo thành công.",
        "deleted": "Xóa mẫu thông báo thành công.",
        "alreadyExists": "Đã tồn tại mẫu thông báo với tên này.",
        "fileRequired": "Tệp là bắt buộc.",
        "importError": "Đã xảy ra lỗi khi nhập mẫu thông báo.",
        "notFound": "Không tìm thấy mẫu thông báo."
      }
    },
    "department": {
      "menuName": "Phòng ban",
      "pageTitle": "Phòng ban",
      "externalId": "Mã ngoài",
      "name": "Tên",
      "isActive": "Đang hoạt động",
      "add": "Thêm phòng ban",
      "edit": "Chỉnh sửa phòng ban",
      "delete": {
        "title": "Xóa phòng ban",
        "text": "Bạn có chắc chắn muốn xóa phòng ban này không?"
      },
      "messages": {
        "created": "Tạo phòng ban thành công.",
        "updated": "Cập nhật phòng ban thành công.",
        "deleted": "Xóa phòng ban thành công."
      }
    },
    "businessArea": {
      "menuName": "Khu vực kinh doanh",
      "pageTitle": "Khu vực kinh doanh",
      "id": "Id",
      "externalId": "Mã ngoài",
      "description": "Mô tả",
      "calendarId": "Lịch",
      "isActive": "Đang hoạt động",
      "edit": "Chỉnh sửa khu vực kinh doanh",
      "messages": {
        "created": "Tạo khu vực kinh doanh thành công.",
        "updated": "Cập nhật khu vực kinh doanh thành công.",
        "deleted": "Xóa khu vực kinh doanh thành công."
      }
    },
    "businessUnit": {
      "menuName": "Đơn vị kinh doanh",
      "pageTitle": "Đơn vị kinh doanh",
      "id": "Id",
      "externalId": "Mã ngoài",
      "description": "Mô tả",
      "isActive": "Đang hoạt động",
      "edit": "Chỉnh sửa đơn vị kinh doanh",
      "messages": {
        "created": "Tạo đơn vị kinh doanh thành công.",
        "updated": "Cập nhật đơn vị kinh doanh thành công.",
        "deleted": "Xóa đơn vị kinh doanh thành công.",
        "inUse": "Bản ghi đơn vị kinh doanh đang được sử dụng. Vui lòng xóa các mục đang sử dụng trước.",
        "notFound": "Không tìm thấy bản ghi đơn vị kinh doanh"
      },
      "add": "Thêm đơn vị kinh doanh",
      "delete": {
        "title": "Xóa đơn vị kinh doanh",
        "text": "Bạn có chắc chắn muốn xóa đơn vị kinh doanh này không?"
      }
    },
    "division": {
      "menuName": "Bộ phận",
      "pageTitle": "Bộ phận",
      "id": "Id",
      "externalId": "Mã ngoài",
      "description": "Mô tả",
      "isActive": "Đang hoạt động",
      "businessUnitId": "Đơn vị kinh doanh",
      "edit": "Chỉnh sửa bộ phận",
      "messages": {
        "created": "Tạo bộ phận thành công.",
        "updated": "Cập nhật bộ phận thành công.",
        "deleted": "Xóa bộ phận thành công."
      },
      "add": "Thêm bộ phận",
      "delete": {
        "title": "Xóa bộ phận",
        "text": "Bạn có chắc chắn muốn xóa bộ phận này không?"
      }
    },
    "organization": {
      "menuName": "Tổ chức",
      "pageTitle": "Tổ chức",
      "id": "Id",
      "externalId": "Mã ngoài",
      "name": "Tên",
      "plantAreaId": "Khu vực nhà máy",
      "organizationParentId": "Tổ chức cha",
      "edit": "Chỉnh sửa tổ chức",
      "messages": {
        "created": "Tạo tổ chức thành công.",
        "updated": "Cập nhật tổ chức thành công.",
        "deleted": "Xóa tổ chức thành công."
      },
      "add": "Thêm tổ chức",
      "delete": {
        "title": "Xóa tổ chức",
        "text": "Bạn có chắc chắn muốn xóa tổ chức này không?"
      }
    },
    "plant": {
      "menuName": "Nhà máy",
      "pageTitle": "Nhà máy",
      "id": "Id",
      "name": "Tên",
      "alias": "Bí danh",
      "isActive": "Đang hoạt động",
      "divisionId": "Bộ phận",
      "countryId": "Quốc gia",
      "employeeCanUpdateGoals": "Nhân viên có thể cập nhật mục tiêu",
      "employeeCanUpdateTracks": "Nhân viên có thể cập nhật kết quả thực tế",
      "employeeCanIncludeKPI": "Nhân viên có thể tạo KPI",
      "managerCanUpdateGoals": "Quản lý có thể cập nhật mục tiêu",
      "managerCanUpdateTracks": "Quản lý có thể cập nhật kết quả thực tế",
      "managerCanIncludeKPI": "Quản lý có thể tạo KPI",
      "edit": "Chỉnh sửa nhà máy",
      "messages": {
        "created": "Tạo nhà máy thành công.",
        "updated": "Cập nhật nhà máy thành công.",
        "deleted": "Xóa nhà máy thành công.",
        "inUse": "Bản ghi nhà máy đang được sử dụng. Vui lòng xóa các mục đang sử dụng trước.",
        "notFound": "Không tìm thấy bản ghi nhà máy",
        "duplicated": "Đã tồn tại nhà máy với bí danh này."
      },
      "add": "Thêm nhà máy",
      "delete": {
        "title": "Xóa nhà máy",
        "text": "Bạn có chắc chắn muốn xóa nhà máy này không?"
      }
    },
    "personnelArea": {
      "menuName": "Khu vực nhân sự",
      "pageTitle": "Khu vực nhân sự",
      "id": "Id",
      "description": "Mô tả",
      "externalId": "Mã ngoài",
      "plantId": "Nhà máy",
      "isActive": "Đang hoạt động",
      "sourceModifiedDate": "Ngày sửa đổi nguồn",
      "edit": "Chỉnh sửa khu vực nhân sự",
      "messages": {
        "created": "Tạo khu vực nhân sự thành công.",
        "updated": "Cập nhật khu vực nhân sự thành công.",
        "deleted": "Xóa khu vực nhân sự thành công.",
        "inUse": "Bản ghi khu vực nhân sự đang được sử dụng. Vui lòng xóa các mục đang sử dụng trước.",
        "notFound": "Không tìm thấy bản ghi khu vực nhân sự",
        "alreadyExists": "Đã tồn tại khu vực nhân sự với mô tả này.",
        "fileRequired": "Tệp là bắt buộc.",
        "importError": "Đã xảy ra lỗi khi nhập khu vực nhân sự.",
        "invalidPlant": "Mã nhà máy không hợp lệ",
        "duplicateExternalId": "Mã ngoài bị trùng lặp",
        "importSuccess": "Nhập khu vực nhân sự thành công. Bạn sẽ nhận được tệp qua email",
        "exportSuccess": "Xuất khu vực nhân sự thành công. Bạn sẽ nhận được tệp qua email",
        "exportFailed": "Xuất khu vực nhân sự không thành công.",
        "importFailed": "Nhập khu vực nhân sự không thành công.",
        "personNotFound": "Không tìm thấy nhân viên để thực hiện nhập dữ liệu. Vui lòng liên hệ quản trị viên.",
        "emailNotFound": "Không tìm thấy email để thực hiện nhập dữ liệu. Vui lòng liên hệ quản trị viên.",
        "importFalied": "Nhập khu vực nhân sự không thành công."
      },
      "add": "Thêm khu vực nhân sự",
      "delete": {
        "title": "Xóa khu vực nhân sự",
        "text": "Bạn có chắc chắn muốn xóa khu vực nhân sự này không?"
      }
    },
    "position": {
      "menuName": "Vị trí",
      "pageTitle": "Vị trí",
      "id": "Id",
      "description": "Mô tả",
      "externalId": "Mã ngoài",
      "active": "Đang hoạt động",
      "jobCode": "Công việc",
      "jobId": "Công việc",
      "organizationId": "Tổ chức",
      "employeeSubGroupId": "Nhóm phụ nhân viên",
      "costCenterId": "Trung tâm chi phí",
      "salaryLevelId": "Bậc lương",
      "businessAreaId": "Khu vực kinh doanh",
      "bonusFrequencyId": "Tần suất thưởng",
      "personnelAreaCode": "Khu vực nhân sự",
      "payGradeType": "Loại ngạch lương",
      "payGradeArea": "Khu vực ngạch lương",
      "employeeGroupId": "Nhóm nhân viên",
      "salaryGroupId": "Nhóm lương",
      "minimum": "Tối thiểu",
      "midpoint": "Trung điểm",
      "edit": "Chỉnh sửa khu vực vị trí",
      "messages": {
        "created": "Tạo vị trí thành công.",
        "updated": "Cập nhật vị trí thành công.",
        "inUse": "Bản ghi vị trí đang được sử dụng. Vui lòng xóa các mục đang sử dụng trước.",
        "notFound": "Không tìm thấy bản ghi vị trí",
        "duplicated": "Đã tồn tại vị trí với mã ngoài/tên này."
      },
      "add": "Thêm vị trí"
    },
    "configuration": {
      "menuName": "Cấu hình",
      "pageTitle": "Cấu hình",
      "key": "Khóa",
      "value": "Giá trị",
      "editorType": "Loại",
      "add": "Thêm cấu hình",
      "edit": "Chỉnh sửa cấu hình",
      "delete": {
        "title": "Xóa cấu hình",
        "text": "Bạn có chắc chắn muốn xóa cấu hình này không?"
      },
      "messages": {
        "created": "Tạo cấu hình thành công.",
        "updated": "Cập nhật cấu hình thành công.",
        "deleted": "Xóa cấu hình thành công."
      },
      "types": {
        "text": "Văn bản",
        "string": "Chuỗi",
        "number": "Số",
        "int": "Số nguyên",
        "boolean": "Boolean"
      }
    },
    "positionProfile": {
      "pageTitle": "Vị trí trọng yếu",
      "globalCritical": "Trọng yếu toàn cầu",
      "countryCritical": "Trọng yếu quốc gia",
      "businessUnitCritical": "Trọng yếu đơn vị kinh doanh",
      "positionType": "Loại vị trí",
      "sucessorType": "Loại người kế nhiệm",
      "potentialSuccessorType": "Loại người kế nhiệm",
      "potentialSuccessorId": "Người kế nhiệm tiềm năng",
      "readinessFactor": "Mức độ sẵn sàng",
      "potentialSuccessorName": "Tên",
      "potentialSuccessorCompany": "Công ty",
      "potentialSuccessorLinkedIn": "URL LinkedIn",
      "potentialSuccessorNotes": "Ghi chú",
      "messages": {
        "created": "Tạo vị trí trọng yếu thành công.",
        "updated": "Cập nhật vị trí trọng yếu thành công."
      }
    },
    "widget": {
      "menuName": "Tiện ích",
      "pageTitle": "Tiện ích",
      "name": "Tên",
      "description": "Mô tả",
      "securityResources": "Tài nguyên bảo mật",
      "link": "Liên kết",
      "query": "Truy vấn SQL",
      "queryRequired": "Truy vấn SQL là bắt buộc.",
      "sqlQueryDateFormatInfo": "Các cột ngày phải được định dạng theo mm/DD/yyyy.",
      "minHeight": "Chiều cao tối thiểu",
      "minWidth": "Chiều rộng tối thiểu",
      "autoApplied": "Áp dụng cho tất cả bảng điều khiển",
      "autoAppliedHelp": "Thao tác này sẽ buộc tiện ích này xuất hiện trên tất cả bảng điều khiển, và người dùng sẽ luôn thấy nó ngay cả khi họ cố xóa.",
      "type": "Loại",
      "category": "Danh mục",
      "add": "Thêm tiện ích",
      "edit": "Chỉnh sửa tiện ích",
      "delete": {
        "title": "Xóa tiện ích",
        "text": "Bạn có chắc chắn muốn xóa tiện ích này không?"
      },
      "examples": {
        "viewSQLExamples": "Xem ví dụ SQL",
        "general": "Chung",
        "generalDescription": "Theo mặc định, hệ thống cung cấp các tham số sau, có thể được tham chiếu trực tiếp trong bất kỳ truy vấn SQL nào của tiện ích.",
        "loggedUserNameDescription": "Tên đăng nhập của người dùng đang đăng nhập (ví dụ: {email}).",
        "loggedUserEmployeeIdDescription": "Mã nhân viên của người dùng đang đăng nhập.",
        "loggedUserLanguageDescription": "Mã ngôn ngữ của người dùng đang đăng nhập (ví dụ: en-US, pt-BR).",
        "loggedUserUniqueIdDescription": "Mã định danh duy nhất của người dùng (Guid)",
        "loggedUserEncryptedUniqueIdDescription": "Mã định danh duy nhất đã mã hóa của người dùng",
        "listDescription": "Mỗi hàng đại diện cho một mục danh sách.",
        "numberDescription": "Trả về một giá trị số duy nhất.",
        "donutDescription": "Nhãn và giá trị phải khớp theo vị trí.",
        "lineDescription": "Mỗi hàng đại diện cho một chuỗi dữ liệu (series)."
      },
      "messages": {
        "created": "Tạo tiện ích thành công.",
        "updated": "Cập nhật tiện ích thành công.",
        "deleted": "Xóa tiện ích thành công.",
        "fileRequired": "Tệp là bắt buộc.",
        "importError": "Đã xảy ra lỗi khi nhập tiện ích.",
        "queryVariablesMissing": "Thiếu các biến sau trong truy vấn của tiện ích: \"{variables}\". Vui lòng thêm chúng vào truy vấn để đảm bảo hoạt động chính xác."
      }
    },
    "reportColumnTemplate": {
      "menuName": "Mẫu cột báo cáo",
      "pageTitle": "Mẫu cột báo cáo",
      "id": "ID",
      "description": "Mô tả",
      "template": "Mẫu",
      "templateHelp": "Sử dụng {value} làm chỗ giữ chỗ cho giá trị ô. Hỗ trợ HTML.",
      "add": "Thêm mẫu",
      "edit": "Chỉnh sửa mẫu",
      "delete": {
        "title": "Xóa mẫu",
        "text": "Bạn có chắc chắn muốn xóa \"{name}\" không?"
      },
      "messages": {
        "created": "Tạo mẫu thành công.",
        "updated": "Cập nhật mẫu thành công.",
        "deleted": "Xóa mẫu thành công."
      }
    },
    "widgetCategory": {
      "menuName": "Danh mục tiện ích",
      "pageTitle": "Danh mục tiện ích",
      "name": "Tên",
      "description": "Mô tả",
      "type": "Loại",
      "add": "Thêm danh mục tiện ích",
      "edit": "Chỉnh sửa danh mục tiện ích",
      "delete": {
        "title": "Xóa danh mục tiện ích",
        "text": "Bạn có chắc chắn muốn xóa danh mục tiện ích này không?"
      },
      "messages": {
        "created": "Tạo danh mục tiện ích thành công.",
        "updated": "Cập nhật danh mục tiện ích thành công.",
        "deleted": "Xóa danh mục tiện ích thành công."
      }
    },
    "widgetType": {
      "menuName": "Loại tiện ích",
      "pageTitle": "Loại tiện ích",
      "name": "Tên",
      "types": {
        "number": "Số",
        "list": "Danh sách",
        "donut": "Biểu đồ tròn",
        "line": "Đường"
      }
    },
    "widgetParameter": {
      "menuName": "Tham số tiện ích",
      "menuTitle": "Tham số tiện ích",
      "title": "Tham số tiện ích",
      "name": "Tên",
      "nameInfo": "Tên dùng để nhận diện tham số trong truy vấn SQL của tiện ích. Không sử dụng dấu cách hoặc ký tự đặc biệt.",
      "nameUniqueError": "Đã tồn tại tham số tiện ích với tên này.",
      "description": "Mô tả",
      "isRequired": "Bắt buộc?",
      "isMultiple": "Nhiều giá trị?",
      "status": "Trạng thái",
      "edit": "Chỉnh sửa tham số tiện ích",
      "add": "Thêm tham số tiện ích",
      "type": "Loại",
      "data": "Truy vấn SQL",
      "dataInfo": "Truy vấn SQL phải trả về hai cột có tên 'Value' và 'Text'.",
      "listOfValues": "Danh sách giá trị",
      "addValue": "Thêm giá trị",
      "value": "Giá trị",
      "label": "Nhãn",
      "delete": {
        "title": "Xóa tham số tiện ích",
        "text": "Bạn có chắc chắn muốn xóa {name} không?"
      },
      "types": {
        "text": "Văn bản",
        "number": "Số",
        "date": "Ngày",
        "boolean": "Boolean",
        "select": "Danh sách",
        "sql": "Danh sách truy vấn"
      },
      "messages": {
        "notFound": "Không tìm thấy tham số tiện ích.",
        "saveSuccess": "Lưu tham số tiện ích thành công.",
        "saveError": "Đã xảy ra lỗi khi lưu tham số tiện ích.",
        "deleteSuccess": "Xóa tham số tiện ích thành công.",
        "deleteError": "Đã xảy ra lỗi khi xóa tham số tiện ích.",
        "isInUse": "Không thể xóa tham số tiện ích vì đang được sử dụng."
      }
    },
    "people": {
      "menuName": "Nhân viên",
      "pageTitle": "Nhân viên",
      "edit": "Chỉnh sửa nhân viên",
      "employeeId": "Mã nhân viên",
      "person": "Nhân viên",
      "id": "Id",
      "name": "Tên",
      "email": "Email",
      "externalId": "Mã ngoài",
      "status": "Trạng thái",
      "type": "Loại",
      "positionShortDescription": "Mô tả ngắn vị trí",
      "hireDate": "Ngày tuyển dụng",
      "culture": "Văn hóa",
      "sourceJTPInstance": "Mã JTP nguồn",
      "documentId": "Mã giấy tờ",
      "manager": "Quản lý",
      "position": "Vị trí",
      "bonusFrequency": "Tần suất thưởng",
      "businessArea": "Khu vực kinh doanh",
      "personnelArea": "Khu vực nhân sự",
      "division": "Bộ phận",
      "plant": "Nhà máy",
      "businessUnit": "Đơn vị kinh doanh",
      "shiftId": "Ca làm việc",
      "plantAreaId": "Khu vực nhà máy",
      "immigrationTypeId": "Loại nhập cư",
      "customerSpecificStatus": "Trạng thái riêng của khách hàng",
      "vendorNumber": "Mã nhà cung cấp",
      "accountNumber": "4 số cuối tài khoản",
      "overrideManagerId": "Ghi đè quản lý",
      "saipAllocation": "Phân bổ SAIP",
      "requirePrivacyConsent": "Nhân viên toàn cầu",
      "globalDirectReports": "Cấp dưới trực tiếp toàn cầu",
      "globalManagerOverrideHelpText": "Các nhân viên được chọn sẽ chỉ báo cáo cho nhân viên này ở phạm vi toàn cầu. Nếu nhân viên này có cấp dưới trực tiếp, tất cả cấp dưới cũng sẽ được đánh dấu là toàn cầu",
      "messages": {
        "updated": "Cập nhật nhân viên thành công.",
        "notFound": "Không tìm thấy bản ghi nhân viên",
        "alreadyExists": "Đã tồn tại nhân viên với mô tả này.",
        "fileRequired": "Tệp là bắt buộc.",
        "importError": "Đã xảy ra lỗi khi nhập danh sách nhân viên.",
        "importSuccess": "Nhập danh sách nhân viên thành công. Bạn sẽ nhận được tệp qua email",
        "importFailed": "Nhập danh sách nhân viên không thành công.",
        "personNotFound": "Không tìm thấy nhân viên để thực hiện nhập dữ liệu. Vui lòng liên hệ quản trị viên.",
        "emailNotFound": "Không tìm thấy email để thực hiện nhập dữ liệu. Vui lòng liên hệ quản trị viên.",
        "importFalied": "Nhập danh sách nhân viên không thành công."
      },
      "personTypes": {
        "unknown": "Không xác định",
        "salariedEmployee": "Nhân viên hưởng lương",
        "contractor": "Nhà thầu",
        "vendor": "Nhà cung cấp",
        "hourlyEmployee": "Nhân viên theo giờ",
        "external": "Bên ngoài",
        "duHourlyInactive": "DU theo giờ - Không hoạt động",
        "duSalariedInactive": "DU hưởng lương - Không hoạt động",
        "duTruckDriverIn": "DU tài xế xe tải",
        "executive": "Điều hành cấp cao",
        "union": "Công đoàn",
        "nonUnion": "Không công đoàn",
        "unionPossible": "Có thể tham gia công đoàn",
        "salariedNonExempt": "Hưởng lương không miễn trừ",
        "hourly": "Theo giờ",
        "duPaidLeave": "DU nghỉ phép có lương",
        "truckDriver": "Tài xế xe tải",
        "duUnpaidLeave": "DU nghỉ phép không lương",
        "workRelease": "Trả tự do có điều kiện",
        "externalAccessLevelOne": "Truy cập bên ngoài cấp độ 1",
        "externalAccessLevelTwo": "Truy cập bên ngoài cấp độ 2",
        "externalAccessLevelThree": "Truy cập bên ngoài cấp độ 3",
        "externalAccessLevelFour": "Truy cập bên ngoài cấp độ 4",
        "externalAccessLevelFive": "Truy cập bên ngoài cấp độ 5",
        "globalEmployee": "Nhân viên toàn cầu"
      },
      "customerSpecificStatuses": {
        "unknown": "Không xác định",
        "active": "Đang hoạt động",
        "inactive": "Không hoạt động",
        "incomeAssistance": "Trợ cấp thu nhập",
        "lOA": "Nghỉ phép dài hạn",
        "retiree": "Đã nghỉ hưu",
        "withdrawn": "Đã rút lui"
      }
    },
    "companyCode": {
      "menuName": "Mã công ty"
    },
    "costCenter": {
      "menuName": "Trung tâm chi phí"
    },
    "currency": {
      "menuName": "Tiền tệ"
    },
    "exchangeRate": {
      "menuName": "Tỷ giá hối đoái"
    }
  },
  "threeHundredSixty": {
    "menuTitle": "360",
    "questionOption": {
      "menuTitle": "Thang đánh giá",
      "pageTitle": "Thang đánh giá",
      "description": "Mô tả",
      "add": "Thêm thang đánh giá",
      "edit": "Chỉnh sửa thang đánh giá",
      "delete": {
        "title": "Xóa thang đánh giá",
        "text": "Bạn có chắc chắn muốn xóa thang đánh giá này không?"
      },
      "messages": {
        "notFound": "Không tìm thấy thang đánh giá.",
        "saveSuccess": "Lưu thang đánh giá thành công.",
        "saveError": "Đã xảy ra lỗi khi lưu thang đánh giá.",
        "deleteSuccess": "Xóa thang đánh giá thành công.",
        "deleteError": "Đã xảy ra lỗi khi xóa thang đánh giá.",
        "isInUse": "Không thể xóa thang đánh giá vì đang được sử dụng.",
        "duplicateName": "Đã tồn tại thang đánh giá với mô tả này."
      },
      "options": {
        "title": "Tùy chọn",
        "value": "Giá trị",
        "description": "Mô tả",
        "explanation": "Giải thích",
        "itemOrder": "Thứ tự",
        "color": "Màu sắc",
        "commentConfig": "Cấu hình nhận xét",
        "add": "Thêm tùy chọn",
        "edit": "Chỉnh sửa tùy chọn",
        "delete": {
          "title": "Xóa tùy chọn",
          "text": "Bạn có chắc chắn muốn xóa tùy chọn này không?"
        },
        "messages": {
          "created": "Tạo tùy chọn thành công.",
          "updated": "Cập nhật tùy chọn thành công.",
          "deleted": "Xóa tùy chọn thành công.",
          "notFound": "Không tìm thấy tùy chọn.",
          "duplicateValue": "Hai hoặc nhiều tùy chọn có cùng giá trị. Mỗi tùy chọn phải có một giá trị duy nhất.",
          "duplicateDescription": "Hai hoặc nhiều tùy chọn có cùng mô tả. Mỗi tùy chọn phải có một mô tả duy nhất."
        },
        "commentConfigType": {
          "followForm": "Theo biểu mẫu",
          "required": "Bắt buộc",
          "notRequired": "Không bắt buộc"
        }
      }
    },
    "questionGroup": {
      "menuTitle": "Nhóm câu hỏi",
      "pageTitle": "Nhóm câu hỏi",
      "name": "Tên",
      "description": "Mô tả",
      "add": "Thêm nhóm câu hỏi",
      "edit": "Chỉnh sửa nhóm câu hỏi",
      "delete": {
        "title": "Xóa nhóm câu hỏi",
        "text": "Bạn có chắc chắn muốn xóa nhóm câu hỏi này: {name}?"
      },
      "messages": {
        "notFound": "Không tìm thấy nhóm câu hỏi.",
        "saveSuccess": "Lưu nhóm câu hỏi thành công.",
        "saveError": "Đã xảy ra lỗi khi lưu nhóm câu hỏi.",
        "deleteSuccess": "Xóa nhóm câu hỏi thành công.",
        "deleteError": "Đã xảy ra lỗi khi xóa nhóm câu hỏi.",
        "isInUse": "Không thể xóa nhóm câu hỏi vì đang được sử dụng."
      }
    },
    "question": {
      "menuTitle": "Câu hỏi",
      "pageTitle": "Câu hỏi",
      "name": "Tên",
      "weight": "Trọng số",
      "commentDisabled": "Tắt nhận xét",
      "description": "Mô tả",
      "questionGroup": "Nhóm câu hỏi",
      "questionOption": "Thang đánh giá",
      "add": "Thêm câu hỏi",
      "edit": "Chỉnh sửa câu hỏi",
      "delete": {
        "title": "Xóa câu hỏi",
        "text": "Bạn có chắc chắn muốn xóa câu hỏi này không?"
      },
      "messages": {
        "notFound": "Không tìm thấy câu hỏi.",
        "saveSuccess": "Lưu câu hỏi thành công.",
        "saveError": "Đã xảy ra lỗi khi lưu câu hỏi.",
        "deleteSuccess": "Xóa câu hỏi thành công.",
        "deleteError": "Đã xảy ra lỗi khi xóa câu hỏi.",
        "isInUse": "Không thể xóa câu hỏi vì đang được sử dụng."
      }
    },
    "formCategory": {
      "menuTitle": "Danh mục biểu mẫu",
      "pageTitle": "Danh mục biểu mẫu",
      "name": "Tên",
      "description": "Mô tả",
      "add": "Thêm danh mục biểu mẫu",
      "edit": "Chỉnh sửa danh mục biểu mẫu",
      "delete": {
        "title": "Xóa danh mục biểu mẫu",
        "text": "Bạn có chắc chắn muốn xóa danh mục biểu mẫu này không?"
      },
      "messages": {
        "notFound": "Không tìm thấy danh mục biểu mẫu.",
        "saveSuccess": "Lưu danh mục biểu mẫu thành công.",
        "saveError": "Đã xảy ra lỗi khi lưu danh mục biểu mẫu.",
        "deleteSuccess": "Xóa danh mục biểu mẫu thành công.",
        "deleteError": "Đã xảy ra lỗi khi xóa danh mục biểu mẫu.",
        "isInUse": "Không thể xóa danh mục biểu mẫu vì đang được sử dụng."
      }
    },
    "formDelegate": {
      "menuTitle": "Ủy quyền biểu mẫu",
      "pageTitle": "Ủy quyền biểu mẫu",
      "form": "Biểu mẫu",
      "manager": "Quản lý",
      "delegate": "Người được ủy quyền",
      "add": "Thêm ủy quyền biểu mẫu",
      "edit": "Chỉnh sửa ủy quyền biểu mẫu",
      "delegatedToPerson": "Ủy quyền cho",
      "invitedEnabled": "Bật mời",
      "signEnabled": "Bật ký",
      "resultViewerEnabled": "Bật xem kết quả",
      "delete": {
        "title": "Xóa ủy quyền biểu mẫu",
        "text": "Bạn có chắc chắn muốn xóa ủy quyền biểu mẫu này không?"
      },
      "messages": {
        "notFound": "Không tìm thấy ủy quyền biểu mẫu.",
        "saveSuccess": "Lưu ủy quyền biểu mẫu thành công.",
        "saveError": "Đã xảy ra lỗi khi lưu ủy quyền biểu mẫu.",
        "deleteSuccess": "Xóa ủy quyền biểu mẫu thành công.",
        "deleteError": "Đã xảy ra lỗi khi xóa ủy quyền biểu mẫu.",
        "managerDisabledMessage": "Bạn không có quyền truy cập biểu mẫu này"
      }
    },
    "formDelegateGlobal": {
      "menuTitle": "Ủy quyền biểu mẫu toàn cầu",
      "pageTitle": "Ủy quyền biểu mẫu toàn cầu"
    },
    "form": {
      "menuTitle": "Biểu mẫu",
      "pageTitle": "Biểu mẫu",
      "id": "Id",
      "description": "Mô tả",
      "category": "Danh mục",
      "categoryId": "Danh mục",
      "stage": {
        "label": "Giai đoạn",
        "preparation": "Chuẩn bị",
        "execution": "Thực hiện",
        "managerReview": "Quản lý xem xét",
        "participantReview": "Người tham gia xem xét",
        "closed": "Đã đóng"
      },
      "active": "Đang hoạt động",
      "maximumHireDate": "Ngày tuyển dụng tối đa",
      "maxPeopleEvaluateAlert": "Cảnh báo số lượng người đánh giá tối đa",
      "includeGlobalReporting": "Báo cáo toàn cầu",
      "customerSpecificStatus": "Trạng thái riêng của khách hàng",
      "employeeType": "Loại nhân viên",
      "reportType": {
        "label": "Loại báo cáo",
        "question": "Theo câu hỏi",
        "questionGroup": "Theo nhóm câu hỏi"
      },
      "directReportBox": "Cấp dưới trực tiếp",
      "selfEvaluationBox": "Tự đánh giá",
      "managerEvaluationBox": "Quản lý đánh giá",
      "crossGroupEvaluationBox": "Đánh giá chéo nhóm",
      "freeEvaluationBox": "Đánh giá tự do",
      "dueDatesBox": "Hạn chót",
      "evaluation": "Đánh giá",
      "comments": "Nhận xét",
      "weight": "Trọng số",
      "minCrossGroupEvaluations": "Số lượng đánh giá chéo nhóm tối thiểu",
      "crossGroupDueDate": "Tạo chéo nhóm – Tự đánh giá",
      "evaluationDueDate": "Tạo chéo nhóm – Quản lý",
      "managerSignDueDate": "Hoàn tất chéo nhóm – Quản lý",
      "participantSignDueDate": "Ngày đóng",
      "processDueDate": "Đánh giá",
      "beginningReviewDate": "Bắt đầu kỳ đánh giá",
      "endingReviewDate": "Kết thúc kỳ đánh giá",
      "maxReleaseQuestionnaireDate": "Phát hành bảng câu hỏi",
      "createdBy": "Người tạo",
      "createdDate": "Ngày tạo",
      "modifiedBy": "Người sửa đổi",
      "modifiedDate": "Ngày sửa đổi",
      "maximumHireDateHelpText": "Ngày tuyển dụng tối đa của nhân viên để tham gia, trừ khi nhân viên đó là quản lý.",
      "maxPeopleEvaluateAlertHelpText": "Hiển thị cảnh báo sau khi nhân viên đạt đến số lượng người đánh giá tối đa",
      "includeGlobalReportingHelpText": "Bao gồm trong báo cáo toàn cầu",
      "directReportEvaluationHelpText": "Đánh giá cấp dưới trực tiếp",
      "directReportCommentsHelpText": "Nhận xét cấp dưới trực tiếp",
      "directReportWeightHelpText": "Trọng số cấp dưới trực tiếp",
      "selfEvaluationHelpText": "Tự đánh giá",
      "selfCommentsHelpText": "Nhận xét tự đánh giá",
      "selfWeightHelpText": "Trọng số tự đánh giá",
      "managerEvaluationHelpText": "Quản lý đánh giá",
      "managerCommentsHelpText": "Nhận xét của quản lý",
      "managerWeightHelpText": "Trọng số của quản lý",
      "freeCommentsHelpText": "Nhận xét tự do",
      "freeWeightHelpText": "Trọng số tự do",
      "crossGroupEvaluationHelpText": "Đánh giá chéo nhóm",
      "crossGroupCommentsHelpText": "Nhận xét chéo nhóm",
      "crossGroupWeightHelpText": "Trọng số chéo nhóm",
      "minCrossGroupEvaluationsHelpText": "Số lượng đánh giá chéo nhóm tối thiểu để cho phép quản lý phát hành bảng câu hỏi.",
      "maxReleaseQuestionnaireDateHelpText": "Ngày tối đa để quản lý phát hành bảng câu hỏi",
      "add": "Thêm biểu mẫu",
      "edit": "Chỉnh sửa biểu mẫu",
      "updateCounters": "Cập nhật bộ đếm",
      "detailedResult": "Kết quả chi tiết",
      "move": {
        "button": "Chuyển đến {stage}",
        "title": "Chuyển giai đoạn",
        "text": "Bạn có chắc chắn muốn chuyển biểu mẫu này sang giai đoạn {stage} không?"
      },
      "duplicate": {
        "button": "Nhân bản",
        "title": "Nhân bản biểu mẫu",
        "text": "Bạn có chắc chắn muốn nhân bản biểu mẫu này không?"
      },
      "delete": {
        "title": "Xóa biểu mẫu",
        "text": "Bạn có chắc chắn muốn xóa biểu mẫu này: {name}?"
      },
      "formQuestion": {
        "title": "Câu hỏi biểu mẫu",
        "question": "Câu hỏi",
        "itemOrder": "Thứ tự",
        "questionGroup": "Nhóm câu hỏi",
        "add": "Thêm câu hỏi",
        "edit": "Chỉnh sửa câu hỏi",
        "delete": {
          "title": "Xóa câu hỏi",
          "text": "Bạn có chắc chắn muốn xóa {name} khỏi biểu mẫu này không?"
        },
        "messages": {
          "saveSuccess": "Lưu câu hỏi biểu mẫu thành công.",
          "saveError": "Đã xảy ra lỗi khi lưu câu hỏi biểu mẫu.",
          "deleteSuccess": "Xóa câu hỏi biểu mẫu thành công.",
          "deleteError": "Đã xảy ra lỗi khi xóa câu hỏi biểu mẫu.",
          "duplicateQuestion": "Câu hỏi này đã được thêm vào biểu mẫu.",
          "notFound": "Không tìm thấy câu hỏi biểu mẫu.",
          "questionNotFound": "Không tìm thấy câu hỏi."
        }
      },
      "messages": {
        "notFound": "Không tìm thấy biểu mẫu.",
        "saveSuccess": "Lưu biểu mẫu thành công.",
        "saveError": "Đã xảy ra lỗi khi lưu biểu mẫu.",
        "deleteSuccess": "Xóa biểu mẫu thành công.",
        "deleteError": "Đã xảy ra lỗi khi xóa biểu mẫu.",
        "deleteNotAllowed": "Không thể xóa biểu mẫu không ở giai đoạn Chuẩn bị.",
        "isInUse": "Không thể xóa biểu mẫu vì đang được sử dụng.",
        "atLeastOneMemberEvaluate": "Phải bật ít nhất một loại người đánh giá (Cấp dưới trực tiếp, Tự đánh giá, Quản lý hoặc Chéo nhóm).",
        "maximumHireDateRequired": "Ngày tuyển dụng tối đa là bắt buộc.",
        "dueDatesRequired": "Tất cả các hạn chót đều là bắt buộc.",
        "moveStageSuccess": "Chuyển biểu mẫu sang giai đoạn tiếp theo thành công.",
        "moveStageNotAllowed": "Không thể chuyển biểu mẫu đã đóng sang giai đoạn khác.",
        "moveStageNotAllowedNoPeople": "Biểu mẫu chưa có nhân viên nào. Để chuyển giai đoạn, hãy vào trang Nhân viên biểu mẫu để thêm nhân viên vào biểu mẫu này.",
        "moveStageNotAllowedNoQuestions": "Biểu mẫu chưa có câu hỏi nào. Để chuyển giai đoạn, hãy thêm ít nhất một câu hỏi.",
        "duplicateSuccess": "Nhân bản biểu mẫu thành công.",
        "updateCountersSuccess": "Đã kích hoạt cập nhật bộ đếm.",
        "detailedResultSuccess": "Đã kích hoạt tạo kết quả chi tiết."
      }
    },
    "formEmailSender": {
      "menuTitle": "Gửi email biểu mẫu",
      "pageTitle": "Gửi email biểu mẫu",
      "messages": {
        "emailsSent": "Gửi email thành công."
      }
    },
    "questionnaire": {
      "questionnaireTypes": {
        "manager": "Quản lý",
        "directReport": "Cấp dưới trực tiếp",
        "crossGroup": "Chéo nhóm",
        "selfEvaluation": "Tự đánh giá",
        "freeEvaluation": "Đánh giá tự do"
      },
      "questionnaireRequestTypes": {
        "default": "Mặc định",
        "manager": "Quản lý",
        "directReport": "Cấp dưới trực tiếp"
      },
      "questionnaireStatus": {
        "done": "Hoàn tất",
        "declined": "Đã từ chối",
        "open": "Đang mở"
      },
      "questionnairePriorityTypes": {
        "selfDirectManager": "Tự đánh giá, Cấp dưới trực tiếp & Quản lý",
        "crossGroupPeers": "Chéo nhóm (Đồng nghiệp)",
        "crossGroup": "Chéo nhóm",
        "freeEvaluation": "Đánh giá tự do"
      },
      "questionnairesReport": {
        "title": "Báo cáo bảng câu hỏi",
        "messages": {
          "confirm": "Tệp sẽ được xuất. Bạn sẽ sớm nhận được kết quả qua email.",
          "success": "Đã kích hoạt xuất báo cáo bảng câu hỏi. Bạn sẽ sớm nhận được kết quả qua email.",
          "emailNotFound": "Không tìm thấy email để thực hiện xuất dữ liệu. Vui lòng liên hệ quản trị viên.",
          "formNotFound": "Không tìm thấy biểu mẫu để thực hiện xuất dữ liệu. Vui lòng liên hệ quản trị viên.",
          "exportFailed": "Xuất báo cáo bảng câu hỏi không thành công."
        }
      },
      "createCrossGroupForMyself": {
        "menuTitle": "Tạo chéo nhóm cho bản thân",
        "pageTitle": "Tạo chéo nhóm cho bản thân",
        "form": "Biểu mẫu",
        "infoMessage": " Dưới đây là nhóm chéo mặc định của bạn. Hãy thêm những nhân viên khác mà bạn muốn được đánh giá bởi họ. Bạn phải có ít nhất năm người thuộc loại \"chéo nhóm\". Quản lý của bạn sẽ xem xét, cập nhật cho phù hợp và phát hành bảng câu hỏi.",
        "warningReleasedQuestionnaires": "Bạn không thể thêm chéo nhóm vì quản lý của bạn đã phát hành bảng câu hỏi về bạn. Vui lòng trao đổi với quản lý về việc thêm bảng câu hỏi khác.",
        "add": "Thêm nhân viên",
        "evaluatorPerson": "Người đánh giá",
        "manager": "Quản lý",
        "type": "Loại",
        "requestType": "Được yêu cầu bởi",
        "released": "Đã phát hành",
        "status": "Trạng thái",
        "actions": "Hành động",
        "delete": {
          "title": "Xóa bảng câu hỏi",
          "text": "Bạn có chắc chắn muốn xóa bảng câu hỏi này không?"
        },
        "messages": {
          "alreadyExists": "Bảng câu hỏi này đã tồn tại cho {names}. Nếu có bất kỳ thắc mắc nào, vui lòng trao đổi với quản lý của bạn.",
          "addSuccess": "Tạo bảng câu hỏi thành công.",
          "deleteSuccess": "Xóa bảng câu hỏi thành công.",
          "invitedPersonWarning": "{names} đã được mời cung cấp phản hồi 360 độ cho ít nhất {limit} biểu mẫu khác. Để đưa họ vào thêm biểu mẫu, chọn 'Lưu'. Nếu phản hồi của họ không thực sự cần thiết, hãy đóng mà không lưu và chọn người khác để cung cấp phản hồi."
        }
      },
      "crossGroupForMyTeam": {
        "menuTitle": "Tạo chéo nhóm cho đội của tôi",
        "pageTitle": "Tạo chéo nhóm cho đội của tôi",
        "form": "Biểu mẫu",
        "manager": "Quản lý",
        "evaluatedPerson": "Người được đánh giá",
        "evaluatorPerson": "Người đánh giá",
        "type": "Loại",
        "released": "Đã phát hành",
        "status": "Trạng thái",
        "loadCrossGroupDefaults": "Tải mặc định chéo nhóm",
        "unloadCrossGroupDefaults": "Bỏ tải mặc định chéo nhóm",
        "releaseQuestionnaire": "Phát hành bảng câu hỏi",
        "add": "Thêm bảng câu hỏi",
        "delete": {
          "title": "Xóa bảng câu hỏi",
          "text": "Bạn có chắc chắn muốn xóa bảng câu hỏi này không?"
        },
        "messages": {
          "alreadyExists": "Bảng câu hỏi này đã tồn tại cho {names}. Nếu có bất kỳ thắc mắc nào, vui lòng trao đổi với quản lý của bạn.",
          "createdSuccess": "Tạo bảng câu hỏi thành công.",
          "deletedSuccess": "Xóa bảng câu hỏi thành công.",
          "saveError": "Đã xảy ra lỗi khi lưu bảng câu hỏi. Vui lòng thử lại.",
          "questionnairesAlreadyExists": "Bảng câu hỏi đã tồn tại cho: {names}.",
          "managerDisabledMessage": "Bạn không có quyền truy cập biểu mẫu chéo nhóm này",
          "releasedSuccess": "Phát hành bảng câu hỏi thành công.",
          "minCrossGroupEvaluations": "Chỉ hiển thị những người có ít nhất {value} bảng câu hỏi chéo nhóm.",
          "noQuestionnairesToRelease": "Không có bảng câu hỏi nào để phát hành. Vui lòng thêm ít nhất một bảng câu hỏi để phát hành.",
          "isReadOnlyDueStage": "Biểu mẫu này chỉ đọc và không thể chỉnh sửa",
          "remoteInstanceWarning": "Đã xảy ra sự cố khi tải thông tin từ xa.",
          "minimumCrossGroupsNotMet": "Cấp dưới trực tiếp chưa đạt số lượng chéo nhóm tối thiểu ({current}/{minimum})",
          "questionnairesReleased": "Đã phát hành bảng câu hỏi",
          "readyForRelease": "Sẵn sàng phát hành"
        },
        "crossGroupDefaults": {
          "loadDefaults": {
            "title": "Tải mặc định chéo nhóm",
            "messages": {
              "confirm": "CẢNH BÁO: Vui lòng xác nhận bạn muốn tải những người tham gia chéo nhóm mặc định cho tất cả cấp dưới trực tiếp.",
              "success": "Tải người tham gia chéo nhóm mặc định thành công."
            }
          },
          "unloadDefaults": {
            "title": "Bỏ tải mặc định chéo nhóm",
            "messages": {
              "confirm": "Vui lòng xác nhận bạn muốn bỏ tải những người tham gia chéo nhóm mặc định cho tất cả cấp dưới trực tiếp.",
              "success": "Bỏ tải người tham gia chéo nhóm mặc định thành công."
            }
          }
        }
      },
      "crossGroupForMyRemoteTeam": {
        "menuTitle": "Tạo chéo nhóm cho đội toàn cầu của tôi",
        "pageTitle": "Tạo chéo nhóm cho đội toàn cầu của tôi"
      },
      "complete": {
        "menuTitle": "Hoàn tất đánh giá",
        "pageTitle": "Hoàn tất đánh giá",
        "form": "Biểu mẫu",
        "questionnaireType": "Loại bảng câu hỏi",
        "submit": "Gửi",
        "notApplicable": "Không áp dụng",
        "declinedCommentPlaceholder": "Không áp dụng",
        "reopen": "Mở lại",
        "status": {
          "new": "Bảng câu hỏi chưa bắt đầu",
          "inProgress": "Bảng câu hỏi đang thực hiện",
          "completed": "Bảng câu hỏi đã hoàn tất"
        },
        "notApplicableTitle": "Từ chối bảng câu hỏi",
        "reopenTitle": "Xác nhận thu hồi",
        "addFreeEvaluation": "Thêm đánh giá tự do",
        "personToEvaluate": "Người cần đánh giá",
        "freeEvaluationWarning": "Đánh giá tự do cần được quản lý phê duyệt và không được tính vào điểm 360 tổng thể.",
        "messages": {
          "loading": "Đang tải bảng câu hỏi...",
          "loadingGlobalQuestionnaires": "Đang tải bảng câu hỏi toàn cầu...",
          "formNotFound": "Không tìm thấy biểu mẫu.",
          "employeeNotFound": "Không tìm thấy nhân viên.",
          "freeEvaluationNotAllowed": "Bạn không thể thêm đánh giá tự do cho chính bạn, quản lý của bạn, đồng nghiệp hoặc cấp dưới của bạn.",
          "alreadyExists": "Đã tồn tại đánh giá cho người này.",
          "submitConfirmation": "Khi nhấn gửi, đánh giá nhân viên đang hiển thị sẽ được ghi nhận. Bạn có thể rút lại các đánh giá đã gửi cho đến khi quy trình 360 chuyển sang bước ký của quản lý.",
          "summaryValidate": "Kiểm tra các câu trả lời và cuộn xuống để gửi. Nhấn vào dấu X ở góc trên bên phải sẽ không hoàn tất việc gửi của bạn.",
          "submitSuccess": "Gửi bảng câu hỏi thành công.",
          "questionnaireNotFound": "Không tìm thấy bảng câu hỏi.",
          "notSubmittedWarningMessage": "Bảng câu hỏi này chưa được gửi và không được tính vào điểm của nhân viên.",
          "noQuestionnaires": "Bạn không có bảng câu hỏi nào cần hoàn tất.",
          "selectQuestionnaire": "Chọn một bảng câu hỏi để hoàn tất.",
          "employeeRateSummary": "Điểm của nhân viên: ",
          "notApplicable": "Nếu bạn không phải là người phù hợp để hoàn tất đánh giá hiệu suất này, bạn có thể từ chối trách nhiệm này sau khi cung cấp lý do.",
          "declineSuccess": "Từ chối bảng câu hỏi thành công.",
          "requiredQuestionnairesCompleted": "Tất cả các đánh giá còn lại có thể được hoàn tất tùy theo quyết định của bạn.",
          "allQuestionsRequired": "Tất cả câu hỏi và nhận xét đều là bắt buộc để gửi.",
          "confirmReopen": "Bạn có chắc chắn muốn thu hồi đánh giá cho {name} không?",
          "reopenSuccess": "Mở lại bảng câu hỏi thành công.",
          "questionnaireAlreadySubmitted": "Bảng câu hỏi này đã được gửi và không thể chỉnh sửa.",
          "addFreeEvaluationSuccess": "Thêm đánh giá tự do thành công."
        }
      },
      "freeEvaluation": {
        "menuTitle": "Xem xét đánh giá tự do",
        "menuTitleGlobal": "Xem xét đánh giá tự do toàn cầu",
        "pageTitle": "Xem xét đánh giá tự do",
        "pageTitleGlobal": "Xem xét đánh giá tự do toàn cầu",
        "evaluatedPerson": "Người được đánh giá",
        "view": "Xem bảng câu hỏi",
        "infoMessage": "Vui lòng xem xét các bảng câu hỏi dưới đây và phê duyệt những bảng bạn đồng ý. Nếu bạn không phê duyệt một bảng câu hỏi, không cần thực hiện thêm hành động nào.",
        "messages": {
          "confirmApproval": "Bạn có chắc chắn muốn phê duyệt bảng câu hỏi này không?",
          "approvalSuccess": "Phê duyệt bảng câu hỏi thành công.",
          "notFound": "Không tìm thấy bảng câu hỏi."
        }
      }
    },
    "formPeople": {
      "participants": {
        "menuTitle": "Người tham gia biểu mẫu",
        "pageTitle": "Người tham gia biểu mẫu",
        "formId": "Biểu mẫu",
        "resetTree": "Đặt lại cây",
        "resetTreeTitle": "Đặt lại cây",
        "resetTreeText": "Bạn có chắc chắn muốn đặt lại cây không?",
        "addPerson": "Thêm người tham gia",
        "changeManager": "Thay đổi quản lý",
        "moveToAnotherManager": "Chuyển sang quản lý khác",
        "downloadTemplate": "Tải mẫu",
        "import": "Nhập",
        "person": "Nhân viên",
        "currentManager": "Quản lý hiện tại",
        "newManager": "Quản lý mới",
        "messages": {
          "noNodeSelected": "Bạn cần chọn ít nhất một nhân viên.",
          "saveSuccess": "Lưu người tham gia biểu mẫu thành công.",
          "resetSuccess": "Đặt lại người tham gia biểu mẫu thành công.",
          "formNotFound": "Không tìm thấy biểu mẫu.",
          "selectEmployee": "Vui lòng chọn một nhân viên trước",
          "addPersonSuccess": "Thêm nhân viên thành công.",
          "changeManagerSuccess": "Thay đổi quản lý thành công.",
          "moveToManagerSuccess": "Chuyển nhân viên sang quản lý mới thành công.",
          "managerNotInTree": "Quản lý đã chọn không có trong cây.",
          "circularManagerSelection": "Không thể chuyển một nhân viên đến một trong những cấp dưới của chính họ.",
          "importSuccess": "Nhập tệp thành công. Bạn sẽ sớm nhận được kết quả qua email."
        },
        "errors": {
          "formInExecution": "Không thể thực hiện hành động này vì biểu mẫu đang trong giai đoạn thực hiện."
        }
      },
      "resultViewer": {
        "menuTitle": "Báo cáo PDF đã phê duyệt",
        "pageTitle": "Báo cáo PDF đã phê duyệt",
        "person": "Nhân viên",
        "personHelpText": "Bạn có thể chọn bản thân hoặc bất kỳ cấp dưới trực tiếp nào của bạn.",
        "personMultipleInstance": "Không chọn nhân viên từ nhiều instance khác nhau. Kết quả có thể không chính xác hoặc không đầy đủ.",
        "manager": "Quản lý",
        "form": "Biểu mẫu",
        "position": "Vị trí",
        "managerFeedback": "Phản hồi của quản lý",
        "employeeFeedback": "Phản hồi của nhân viên",
        "pdfReport": "Báo cáo PDF",
        "pdfReportFreeEvaluation": "PDF đánh giá tự do",
        "pdfReportFreeEvaluationNonApproved": "PDF đánh giá tự do chưa được phê duyệt",
        "downloadSelected360Report": "Tải báo cáo 360 đã chọn",
        "downloadSelectedFreeEvaluationReport": "Tải báo cáo đánh giá tự do đã chọn",
        "downloadSelectedNonApprovedFreeEvaluationReport": "Tải báo cáo đánh giá tự do chưa được phê duyệt đã chọn",
        "emailSelected360Report": "Tải báo cáo 360 đã chọn",
        "emailSelectedFreeEvaluationReport": "Tải báo cáo đánh giá tự do đã chọn",
        "emailSelectedNonApprovedFreeEvaluationReport": "Tải báo cáo đánh giá tự do chưa được phê duyệt đã chọn",
        "bulkEmailQueued": "Báo cáo của bạn đang được chuẩn bị. Bạn sẽ sớm nhận được email đính kèm tệp PDF.",
        "bulkEmailNoSelection": "Vui lòng chọn ít nhất một hàng.",
        "bulkEmailInvalidSelection": "Một hoặc nhiều hàng đã chọn không hợp lệ với quyền truy cập của bạn.",
        "bulkEmailNoReportForKind": "Các hàng đã chọn không bao gồm loại báo cáo này.",
        "showFeedback": "Hiển thị phản hồi",
        "downloadEvaluationSelectOne": "Chọn một nhân viên hoặc quản lý.",
        "validationSelectPersonOrManager": "Chọn một nhân viên hoặc quản lý để chạy bộ lọc.",
        "successPdfByEmail": "Đã gửi tệp PDF thành công đến email của bạn."
      },
      "sign": {
        "menuTitle": "Ký các đánh giá đang chờ",
        "pageTitle": "Ký các đánh giá đang chờ",
        "menuTitleGlobal": "Ký các đánh giá đang chờ toàn cầu",
        "pageTitleGlobal": "Ký các đánh giá đang chờ toàn cầu",
        "form": "Biểu mẫu",
        "managerOrPerson": "Quản lý/Nhân viên",
        "person": "Nhân viên",
        "pdfReport": "Báo cáo PDF",
        "pdfReportFreeEvaluation": "Báo cáo PDF đánh giá tự do",
        "sign": "Ký",
        "signed": "Đã ký",
        "signTitle": "Ký đánh giá",
        "managerSign": "Quản lý ký",
        "personSign": "Nhân viên ký",
        "signatureComments": "Nhận xét chữ ký",
        "updateComment": "Cập nhật nhận xét",
        "messages": {
          "signedBy": "Được ký bởi {name} vào {date}",
          "signConfirmationManager": "Mọi thông tin bổ sung liên quan đến quá trình phản hồi với cấp dưới trực tiếp của bạn có thể được cung cấp bên dưới.",
          "signConfirmationPerson": "Bằng cách chọn ký, bạn xác nhận rằng bạn đã có buổi trao đổi phản hồi với quản lý của bạn về đánh giá này.",
          "signConfirmationWarning": "Bằng cách chọn ký, tệp PDF sẽ được phát hành cho nhân viên.",
          "managerSignatureNotAllowed": "Bạn không thể ký đánh giá này vì quản lý đã ký rồi.",
          "employeeSignatureNotAllowed": "Bạn không thể ký đánh giá này vì nhân viên đã ký rồi.",
          "successMessage": "Ký đánh giá thành công.",
          "updateCommentSuccessMessage": "Cập nhật nhận xét thành công.",
          "noComments": "Bạn phải cung cấp nhận xét trước khi ký."
        }
      }
    }
  },
  "security": {
    "menuTitle": "Bảo mật",
    "resource": {
      "menuName": "Tài nguyên",
      "pageTitle": "Tài nguyên",
      "add": "Thêm tài nguyên",
      "edit": "Chỉnh sửa tài nguyên",
      "delete": {
        "title": "Xóa tài nguyên",
        "text": "Bạn có chắc chắn muốn xóa tài nguyên này không?"
      },
      "id": "Id",
      "name": "Tên",
      "description": "Mô tả",
      "resourceType": "Loại tài nguyên",
      "isActive": "Đang hoạt động",
      "messages": {
        "created": "Tạo tài nguyên thành công.",
        "updated": "Cập nhật tài nguyên thành công.",
        "deleted": "Xóa tài nguyên thành công.",
        "notFound": "Không tìm thấy bản ghi tài nguyên",
        "duplicateName": "Đã tồn tại tài nguyên với tên này.",
        "inUse": "Bản ghi tài nguyên đang được sử dụng. Vui lòng xóa các mục đang sử dụng trước."
      }
    },
    "user": {
      "menuName": "Người dùng",
      "pageTitle": "Người dùng",
      "subgridName": "Tài khoản người dùng",
      "uniqueId": "Mã định danh duy nhất",
      "add": "Thêm tài khoản người dùng",
      "edit": "Chỉnh sửa tài khoản người dùng",
      "delete": {
        "title": "Xóa tài khoản người dùng",
        "text": "Bạn có chắc chắn muốn xóa tài khoản người dùng này không?"
      },
      "personId": "Id",
      "provider": "Nhà cung cấp",
      "userName": "Tên người dùng",
      "isActive": "Đang hoạt động",
      "messages": {
        "created": "Tạo tài khoản người dùng thành công.",
        "updated": "Cập nhật tài khoản người dùng thành công.",
        "deleted": "Xóa tài khoản người dùng thành công.",
        "notFound": "Không tìm thấy bản ghi tài khoản người dùng",
        "duplicateName": "Tên người dùng này đã tồn tại."
      }
    },
    "group": {
      "menuName": "Nhóm",
      "pageTitle": "Nhóm",
      "add": "Thêm nhóm",
      "edit": "Chỉnh sửa nhóm",
      "delete": {
        "title": "Xóa nhóm?",
        "text": "Bạn có chắc chắn muốn xóa nhóm này không?"
      },
      "id": "Id",
      "name": "Tên",
      "description": "Mô tả",
      "isActive": "Đang hoạt động",
      "overwriteGroups": "Ghi đè nhóm",
      "messages": {
        "created": "Tạo nhóm thành công.",
        "updated": "Cập nhật nhóm thành công.",
        "deleted": "Xóa nhóm thành công.",
        "notFound": "Không tìm thấy bản ghi nhóm",
        "duplicateName": "Đã tồn tại nhóm với tên này.",
        "fileRequired": "Tệp là bắt buộc.",
        "imported": "Nhập nhóm thành công"
      }
    },
    "groupPeople": {
      "menuName": "Nhân viên trong nhóm",
      "pageTitle": "Nhân viên trong nhóm",
      "add": "Thêm nhân viên vào nhóm",
      "edit": "Chỉnh sửa nhân viên trong nhóm",
      "delete": {
        "title": "Xóa nhân viên trong nhóm",
        "text": "Bạn có chắc chắn muốn xóa nhân viên trong nhóm này không?"
      },
      "groupId": "Nhóm",
      "personId": "Nhân viên",
      "validityStart": "Ngày bắt đầu hiệu lực",
      "validityEnd": "Ngày kết thúc hiệu lực",
      "messages": {
        "created": "Tạo nhân viên trong nhóm thành công.",
        "updated": "Cập nhật nhân viên trong nhóm thành công.",
        "deleted": "Xóa nhân viên trong nhóm thành công.",
        "notFound": "Không tìm thấy bản ghi nhân viên trong nhóm",
        "alreadyExists": "Người dùng này đã sử dụng nhóm này."
      }
    },
    "groupPermission": {
      "menuName": "Quyền của nhóm",
      "pageTitle": "Quyền của nhóm",
      "add": "Thêm quyền của nhóm",
      "edit": "Chỉnh sửa quyền của nhóm",
      "delete": {
        "title": "Xóa quyền của nhóm",
        "text": "Bạn có chắc chắn muốn xóa quyền của nhóm này không?"
      },
      "groupId": "Nhóm",
      "resourceId": "Tài nguyên",
      "action": "Hành động",
      "messages": {
        "created": "Tạo quyền của nhóm thành công.",
        "updated": "Cập nhật quyền của nhóm thành công.",
        "deleted": "Xóa quyền của nhóm thành công.",
        "notFound": "Không tìm thấy bản ghi quyền của nhóm",
        "duplicateName": "Đã tồn tại quyền với tài nguyên/quyền này."
      }
    }
  },
  "goals": {
    "menuName": "Mục tiêu",
    "kpi": {
      "menuName": "KPI"
    },
    "plan": {
      "menuName": "Kế hoạch"
    },
    "target": {
      "menuName": "Chỉ tiêu",
      "kpiOwner": {
        "menuName": "Chỉ tiêu - Chủ sở hữu KPI"
      }
    },
    "actual": {
      "menuName": "Thực tế",
      "kpiOwner": {
        "menuName": "Thực tế - Chủ sở hữu KPI"
      }
    },
    "discussionNotes": {
      "menuName": "Ghi chú thảo luận"
    },
    "flexibleGoal": {
      "menuName": "Mục tiêu linh hoạt"
    },
    "actionPlan": {
      "menuName": "Kế hoạch hành động"
    },
    "library": {
      "menuName": "Thư viện"
    },
    "category": {
      "menuName": "Danh mục"
    },
    "PlantArea": {
      "menuName": "Khu vực nhà máy"
    },
    "clerks": {
      "menuName": "Chủ sở hữu KPI"
    },
    "quickEntry": {
      "menuName": "Nhập nhanh hàng năm"
    }
  },
  "nineBox": {
    "menuName": "Ma trận 9 ô",
    "nineBoxForm": {
      "menuName": "Biểu mẫu"
    },
    "nineBoxFormPeople": {
      "menuName": "Người tham gia biểu mẫu"
    },
    "fillTalentTalk": {
      "menuName": "Điền trao đổi nhân tài"
    },
    "nineBoxCalibration": {
      "menuName": "Hiệu chỉnh"
    },
    "fillDevelopmentPlan": {
      "menuName": "Điền kế hoạch phát triển"
    }
  },
  "pcf": {
    "menuName": "PCF",
    "dashboard": {
      "menuName": "Bảng điều khiển"
    },
    "request": {
      "newPCF": {
        "menuName": "PCF mới"
      }
    },
    "requestType": {
      "menuName": "Loại yêu cầu"
    },
    "approvalGroup": {
      "menuName": "Nhóm phê duyệt"
    },
    "requestStatuses": {
      "menuName": "Trạng thái yêu cầu"
    },
    "catalog": {
      "menuName": "Danh mục"
    },
    "immigrationType": {
      "menuName": "Loại nhập cư"
    }
  },
  "merit": {
    "menuName": "Tăng lương theo thành tích",
    "meritPlanFormList": {
      "menuName": "Người tham gia biểu mẫu"
    },
    "meritDashboard": {
      "menuName": "Bảng điều khiển"
    },
    "meritPlan": {
      "menuName": "Kế hoạch"
    },
    "awardLetter": {
      "menuName": "Thư khen thưởng"
    },
    "meritPlanParticipants": {
      "menuName": "Người tham gia kế hoạch"
    }
  },
  "bonus": {
    "menuName": "Thưởng",
    "bonusIncentiveGroup": {
      "menuName": "Nhóm khuyến khích"
    },
    "bonusPlan": {
      "menuName": "Kế hoạch"
    },
    "bonusPlanParticipants": {
      "menuName": "Người tham gia kế hoạch"
    },
    "bonusDashboard": {
      "menuName": "Bảng điều khiển"
    },
    "awardLetter": {
      "menuName": "Thư khen thưởng"
    },
    "saipAllocation": {
      "menuName": "Phân bổ SAIP",
      "messages": {
        "notFound": "Không tìm thấy phân bổ SAIP.",
        "saveError": "Đã xảy ra lỗi khi lưu phân bổ SAIP. Vui lòng thử lại.",
        "saveSuccess": "Lưu phân bổ SAIP thành công.",
        "deleteSuccess": "Xóa phân bổ SAIP thành công.",
        "isInUse": "Phân bổ SAIP đang được sử dụng và không thể xóa.",
        "duplicateValueCode": "Giá trị phân bổ SAIP không được trùng mã.",
        "duplicateExternalId": "Đã tồn tại phân bổ SAIP với mã ngoài này.",
        "valuesSumExceeded": "Tổng giá trị phân bổ SAIP không được vượt quá 100%."
      }
    }
  },
  "cultureTalent": {
    "menuName": "Văn hóa & Nhân tài",
    "culture": {
      "menuName": "Chương trình văn hóa và nhân tài"
    },
    "talent": {
      "menuName": "Nền tảng đào tạo"
    }
  },
  "talentMapping": {
    "menuName": "Lập bản đồ nhân tài",
    "skills": {
      "menuName": "Kỹ năng"
    },
    "orgChart": {
      "menuName": "Sơ đồ tổ chức"
    },
    "myProfile": {
      "menuName": "Hồ sơ của tôi"
    },
    "degreeTypes": {
      "menuName": "Loại bằng cấp",
      "pageTitle": "Loại bằng cấp",
      "name": "Tên",
      "isActive": "Đang hoạt động",
      "add": "Thêm loại bằng cấp",
      "edit": "Chỉnh sửa loại bằng cấp",
      "delete": {
        "title": "Xóa loại bằng cấp",
        "text": "Bạn có chắc chắn muốn xóa loại bằng cấp này không?"
      },
      "messages": {
        "created": "Tạo loại bằng cấp thành công.",
        "updated": "Cập nhật loại bằng cấp thành công.",
        "deleted": "Xóa loại bằng cấp thành công.",
        "saveError": "Đã xảy ra lỗi khi lưu loại bằng cấp. Vui lòng thử lại.",
        "notFound": "Không tìm thấy bản ghi loại bằng cấp.",
        "inUse": "Loại bằng cấp đang được sử dụng và không thể xóa."
      }
    }
  },
  "absenceRequest": {
    "menuName": "Yêu cầu nghỉ phép",
    "createRequest": {
      "menuName": "Tạo yêu cầu"
    },
    "viewManageRequests": {
      "menuName": "Yêu cầu của tôi"
    },
    "calendar": {
      "menuName": "Lịch"
    },
    "pendingRequestsAndHistory": {
      "menuName": "Phê duyệt"
    },
    "manageDirectReportsHours": {
      "menuName": "Duy trì số dư"
    },
    "upload": {
      "menuName": "Tải lên"
    },
    "manageAbsenceProfiles": {
      "menuName": "Quản lý hồ sơ nghỉ phép"
    },
    "manageHolidays": {
      "menuName": "Quản lý ngày lễ"
    },
    "hoursCalculationMatrices": {
      "menuName": "Ma trận tính giờ"
    },
    "manageApprovingDelegate": {
      "menuName": "Ủy quyền phê duyệt"
    },
    "notification": {
      "menuName": "Thông báo nghỉ phép"
    },
    "manageMatrixCategories": {
      "menuName": "Quản lý danh mục ma trận"
    },
    "manageFloatingHolidayMatrix": {
      "menuName": "Quản lý ma trận ngày nghỉ linh hoạt"
    },
    "manageSickMatrix": {
      "menuName": "Quản lý ma trận nghỉ ốm"
    }
  },
  "expenseReport": {
    "menuName": "Báo cáo chi phí",
    "createExpenses": {
      "menuName": "Tạo yêu cầu"
    },
    "myExpenses": {
      "menuName": "Yêu cầu của tôi"
    },
    "approvals": {
      "menuName": "Chi phí cần phê duyệt"
    },
    "delegateApprovals": {
      "menuName": "Ủy quyền phê duyệt"
    },
    "preparers": {
      "menuName": "Người lập"
    },
    "categories": {
      "menuName": "Danh mục"
    },
    "distanceRates": {
      "menuName": "Đơn giá khoảng cách"
    },
    "generalLedgers": {
      "menuName": "Sổ cái tổng hợp"
    },
    "policies": {
      "menuName": "Chính sách"
    },
    "projects": {
      "menuName": "Dự án"
    }
  },
  "salaryExtraPay": {
    "menuName": "Lương ngày thứ 6/7",
    "createRequest": {
      "menuName": "Tạo yêu cầu"
    },
    "myRequests": {
      "menuName": "Yêu cầu của tôi"
    },
    "approvals": {
      "menuName": "Phê duyệt"
    },
    "delegateApprovals": {
      "menuName": "Ủy quyền phê duyệt"
    },
    "locationSetups": {
      "menuName": "Thiết lập địa điểm"
    },
    "export": {
      "menuName": "Xuất"
    },
    "policies": {
      "menuName": "Chính sách"
    },
    "payType": {
      "menuName": "Loại lương"
    },
    "personnelAreaSetups": {
      "menuName": "Thiết lập khu vực nhân sự"
    }
  },
  "developmentPlan": {
    "menuName": "Kế hoạch phát triển",
    "planDelegate": {
      "menuName": "Ủy quyền kế hoạch"
    },
    "questions": {
      "menuName": "Câu hỏi"
    },
    "plans": {
      "menuName": "Kế hoạch"
    },
    "programs": {
      "menuName": "Chương trình"
    },
    "notificationSender": {
      "menuName": "Gửi thông báo"
    },
    "fillDevelopmentPlan": {
      "menuName": "Điền kế hoạch phát triển"
    },
    "signEvaluations": {
      "menuName": "Ký đánh giá"
    },
    "resultViewer": {
      "menuName": "Xem kết quả"
    }
  },
  "survey": {
    "menuName": "Khảo sát",
    "questionCategories": {
      "menuName": "Danh mục câu hỏi"
    },
    "questions": {
      "menuName": "Câu hỏi"
    },
    "ratingScales": {
      "menuName": "Thang đánh giá"
    },
    "actionPlans": {
      "menuName": "Kế hoạch hành động"
    },
    "people": {
      "menuName": "Nhân viên"
    },
    "surveys": {
      "menuName": "Biểu mẫu khảo sát"
    },
    "notificationSender": {
      "menuName": "Gửi thông báo"
    },
    "dashboard": {
      "menuName": "Bảng điều khiển"
    }
  },
  "hourlyPositions": {
    "menuName": "Vị trí theo giờ",
    "createRequest": {
      "menuName": "Tạo yêu cầu"
    },
    "requests": {
      "menuName": "Yêu cầu"
    },
    "employeeSubgroup": {
      "menuName": "Nhóm phụ nhân viên"
    },
    "hourlyCatalog": {
      "menuName": "Danh mục theo giờ"
    }
  },
  "vuestic": {
    "search": "Tìm kiếm",
    "noOptions": "Không tìm thấy mục nào",
    "ok": "Đồng ý",
    "cancel": "Hủy",
    "uploadFile": "Chọn tệp",
    "undo": "Hoàn tác",
    "dropzone": "Thả tệp vào đây để tải lên",
    "fileDeleted": "Đã xóa tệp",
    "closeAlert": "đóng thông báo",
    "backToTop": "về đầu trang",
    "toggleDropdown": "bật/tắt danh sách thả xuống",
    "carousel": "băng chuyền",
    "goPreviousSlide": "đến trang trước",
    "goNextSlide": "đến trang tiếp theo",
    "goSlide": "đến trang {index}",
    "slideOf": "trang {index} trong {length}",
    "close": "đóng",
    "openColorPicker": "mở bảng chọn màu",
    "colorSelection": "chọn màu",
    "colorName": "màu {color}",
    "decreaseCounter": "giảm bộ đếm",
    "increaseCounter": "tăng bộ đếm",
    "selectAllRows": "chọn tất cả các hàng",
    "sortColumnBy": "sắp xếp cột theo {name}",
    "selectRowByIndex": "chọn hàng {index}",
    "resetDate": "đặt lại ngày",
    "nextPeriod": "kỳ tiếp theo",
    "switchView": "chuyển chế độ xem",
    "previousPeriod": "kỳ trước",
    "removeFile": "xóa tệp",
    "reset": "đặt lại",
    "pagination": "phân trang",
    "goToTheFirstPage": "đến trang đầu tiên",
    "goToPreviousPage": "đến trang trước",
    "goToSpecificPage": "đến trang {page}",
    "goToSpecificPageInput": "nhập số trang",
    "goNextPage": "đến trang tiếp theo",
    "goLastPage": "đến trang cuối cùng",
    "currentRating": "đánh giá hiện tại {value} trên {max}",
    "voteRating": "bình chọn {value} trên {max}",
    "optionsFilter": "bộ lọc tùy chọn",
    "splitPanels": "chia bảng",
    "movePaginationLeft": "di chuyển phân trang sang trái",
    "movePaginationRight": "di chuyển phân trang sang phải",
    "resetTime": "đặt lại giờ",
    "closeToast": "đóng thông báo",
    "selectedOption": "Tùy chọn đã chọn",
    "noSelectedOption": "Chưa chọn tùy chọn nào",
    "breadcrumbs": "đường dẫn điều hướng",
    "counterValue": "giá trị bộ đếm",
    "selectedDate": "ngày đã chọn",
    "selectedTime": "giờ đã chọn",
    "progressState": "trạng thái tiến trình",
    "color": "màu sắc",
    "next": "Tiếp theo",
    "back": "Quay lại",
    "finish": "Hoàn tất",
    "step": "bước",
    "progress": "tiến trình",
    "loading": "Đang tải",
    "sliderValue": "Giá trị thanh trượt hiện tại là {value}",
    "switch": "Chuyển đổi",
    "inputField": "Trường nhập liệu",
    "fileTypeIncorrect": "Loại tệp không đúng",
    "select": "Chọn một tùy chọn"
  },
  "orgChart": {
    "title": "Sơ đồ tổ chức",
    "menuTitle": "Sơ đồ tổ chức",
    "menuName": "Sơ đồ tổ chức",
    "organization": "Tổ chức",
    "directReports": "Cấp dưới trực tiếp",
    "showEmployeeDetails": "Hiển thị chi tiết nhân viên",
    "goUp": "Lên một cấp",
    "navigateHere": "Điều hướng đến đây",
    "vacant": "Đang trống",
    "legend": {
      "active": "Đang hoạt động",
      "inactive": "Không hoạt động",
      "termed": "Đã chấm dứt",
      "vacant": "Đang trống"
    },
    "position": "Vị trí",
    "plant": "Nhà máy",
    "businessArea": "Khu vực kinh doanh",
    "personnelArea": "Khu vực nhân sự",
    "costCenter": "Trung tâm chi phí",
    "hireDate": "Ngày tuyển dụng",
    "score360": "Điểm 360",
    "scoreGoals": "Điểm mục tiêu",
    "score9box": "Ma trận 9 ô",
    "person": "Nhân viên",
    "employeeType": "Loại nhân viên",
    "employeeStatus": "Trạng thái nhân viên",
    "status": "Trạng thái",
    "view": "Xem",
    "viewOptions": {
      "basic": "Cơ bản",
      "performance": "Hiệu suất",
      "headcount": "Số lượng nhân viên"
    },
    "headcount": {
      "directTotal": "Tổng cấp dưới trực tiếp",
      "directSESNE": "Trực tiếp SE/SNE",
      "total": "Tổng số nhân viên",
      "spanOfControl": "Phạm vi quản lý",
      "se": "Nhân viên hưởng lương",
      "sne": "Nhân viên SNE",
      "hourly": "Nhân viên theo giờ",
      "truck": "Nhân viên lái xe tải",
      "work": "Nhân viên trả tự do có điều kiện"
    },
    "hidePeers": "Ẩn đồng nghiệp",
    "showPeers": "Hiển thị đồng nghiệp",
    "collapse": "Thu gọn",
    "expand": "Mở rộng",
    "errors": {
      "salariedTypeCannotBeRemoved": "Không thể xóa loại nhân viên hưởng lương.",
      "employeeNotInTree": "Nhân viên này nằm ngoài cây sơ đồ tổ chức và không thể hiển thị."
    }
  }
}
